'use strict';

var BlimpExtListingUtilities = new Class({
	Extends: BlimpExt,
	options: {
		pg_width_by_thumbs: 5,
		data: null
	},

	post_process_build: function post_process_build() {
		this.parent();
		if (!this.first_load) {
			this.set_default_view();
		} else {
			if (this._link.hasClass('gallery_link')) {
				this.status_view = 'pg';
			} else if (this._link.hasClass('floorplan_link')) {
				this.status_view = 'fp';
			} else {
				this.status_view = 'mp';
			}

			if (this.status_view == 'mp') {
				this._monitor = this._element.getElement('.map_container');
				this.initialize_map();
			} else {
				this._monitor = this._element.getElement('.photogallery_container');
				this.create_gallery();
			}

			this.add_links();
		}

		this.first_load = false;
	},

	add_links: function add_links() {
		var _link_container = this._element.getElement('.link_container');

		if (!_link_container || !_link_container.hasClass('_for_listing')) return;

		this._contact_btn = _link_container.getElement('.contact_btn a');

		if (!this._link.getParent('.lst') || !this._link.getParent('.lst').getElement('.map_view') && !this._contact_btn && (this.data.photos.length == 0 || this.data.floorplan.length == 0)) {
			_link_container.dispose();
		} else {
			if (this._link.getParent('.lst').getElement('.map_view')) {
				this._mp_link = new Element('a', {
					'href': '#',
					'text': 'View Map',
					'class': 'map_view raquo ' + (this.status_view == 'mp' ? '_active' : ''),
					'data-rpc': this._link.getParent('.lst').getElement('.map_view').getAttribute('data-rpc-map')
				}).inject(_link_container, 'top');
			}

			if (this._link.getParent('.lst').getElement('.floorplan_link') || this.data.floorplan && this.data.floorplan.length > 0) {
				this._fp_link = new Element('a', {
					'href': '#',
					'text': 'View Floorplan',
					'class': 'floorplan raquo ' + (this.status_view == 'fp' ? '_active' : ''),
					'data-rpc': this._link.getParent('.lst').getElement('.floorplan_link').getAttribute('data-rpc')
				}).inject(_link_container, 'top');
			}

			if (this._link.getParent('.lst').getElement('.gallery_link') || this.data.photos && this.data.photos.length > 0) {
				this._pg_link = new Element('a', {
					'href': '#',
					'text': 'View Photo Gallery',
					'class': 'photogallery raquo ' + (this.status_view == 'pg' ? '_active' : ''),
					'data-rpc': this._link.getParent('.lst').getElement('.gallery_link').getAttribute('data-rpc')
				}).inject(_link_container, 'top');
			}
		}

		// to have some space so the contact btn wont overlapped with the gallery widget if theres no listed by and managed by
		if (this._pg_link && this._fp_link && this._mp_link && _link_container.getElement('.contact_btn') && !this._element.getElement('.listed_by') && !this._element.getElement('.managed_by')) {

			var _header = this._element.getElement('h3');

			if (_header) _header.setStyle('padding-bottom', 30);
		}

		this.add_links_functionality();
	},

	add_links_functionality: function add_links_functionality() {
		var _fp, _pg, _mp;

		if (this._fp_link) {
			this._fp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'pg') {
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if (_pg) _pg.dispose();

				if (this.status_view == 'mp') {
					_mp = this._monitor.getElement('.map');
				}

				if (_mp) _mp.dispose();

				if (!_fp) {
					var data = null;

					if (this.data.floorplan) {
						data = {
							photos: this.data.floorplan,
							content: this.data.content
						};
					}

					this.initialize_gallery(this._monitor, data);
					_fp = this._monitor.getElement('.w_photogallery');
				} else {
					this._monitor.adopt(_fp);
				}

				if (this._pg_link) this._pg_link.removeClass('_active');

				if (this._mp_link) this._mp_link.removeClass('_active');

				this._fp_link.addClass('_active');
				this.status_view = 'fp';
			}.bind(this));
		}

		if (this._pg_link) {
			this._pg_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'fp') {
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if (_fp) _fp.dispose();

				if (this.status_view == 'mp') {
					_mp = this._monitor.getElement('.map');
				}

				if (_mp) _mp.dispose();

				if (!_pg) {
					var data = this.data.photos ? this.data : null;

					this.initialize_gallery(this._monitor, data);
					_pg = this._monitor.getElement('.w_photogallery');
				} else {
					this._monitor.adopt(_pg);
				}

				if (this._fp_link) this._fp_link.removeClass('_active');

				if (this._mp_link) this._mp_link.removeClass('_active');

				this._pg_link.addClass('_active');
				this.status_view = 'pg';
			}.bind(this));
		}

		if (this._mp_link) {
			this._mp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'pg') {
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if (_pg) _pg.dispose();

				if (this.status_view == 'fp') {
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if (_fp) _fp.dispose();

				if (!_mp) {
					this.initialize_map();
					_mp = this._monitor.getElement('.map');
				} else {
					this._monitor.adopt(_mp);
				}

				if (this._pg_link) this._pg_link.removeClass('_active');

				if (this._fp_link) this._fp_link.removeClass('_active');

				this._mp_link.addClass('_active');
				this.status_view = 'mp';
			}.bind(this));
		}

		if (this._contact_btn && this._link.getParent('.ava_apts')) {
			new Blimp.Form(this._contact_btn, { draggable: true, allow_others: true });
		}
	},

	set_default_view: function set_default_view() {
		if (this._element.getElement('.w_popup').hasClass('floorplan') && this.status_view != 'fp') {
			if (this._fp_link) this._fp_link.fireEvent('click');
		} else if (this._element.getElement('.w_popup').hasClass('photogallery') && this.status_view != 'pg') {
			if (this._pg_link) this._pg_link.fireEvent('click');
		} else if (this.status_view != 'mp') {
			if (this._mp_link) this._mp_link.fireEvent('click');
		}
	},

	create_gallery: function create_gallery() {
		if (!this.photogallery) {
			var fp_data;
			this.data = this.data || this.options.data;

			if (this._element.getElement('.w_popup').hasClass('floorplan') && this.data.floorplan) {
				fp_data = {
					photos: this.data.floorplan && this.data.floorplan.length > 0 ? this.data.floorplan : this.data.photos,
					content: this.data.content
				};
			}

			var _phg = this._element.getElement('.w_photogallery');

			var data = fp_data || this.data;

			this.initialize_gallery(_phg, data);

			//this.photogallery.popup = this;
		}
	},

	initialize_gallery: function initialize_gallery(_element, data) {
		var self = this;

		if (data) {
			new PagePhotogallery(_element, {
				data: data,
				thumbs_amount: this.options.width_by_thumbs,
				no_fullscreen_opt: true
			});
		} else {
			var rpc;

			if (this.status_view == 'fp') {
				rpc = this._fp_link.getAttribute('data-rpc');
			} else {
				rpc = this._pg_link.getAttribute('data-rpc');
			}

			self.remote = new Remote({
				rpc: rpc,
				method: 'get',
				onSuccess: function onSuccess() {
					var data = this.get_data();

					self.data.content = data.content;
					self.data.photos = data.photos;
					self.data.floorplan = data.floorplan;

					if (self.status_view == 'fp') {
						data = {
							photos: data.floorplan,
							content: data.content
						};
					}

					new PagePhotogallery(_element, {
						data: data,
						thumbs_amount: self.options.width_by_thumbs,
						no_fullscreen_opt: true
					});
				}
			});
		}
	},

	initialize_map: function initialize_map() {
		var self = this;
		var rpc = this._mp_link ? this._mp_link.getAttribute('data-rpc') : this._link.getAttribute('data-rpc-map');
		var _map = new Element('div', {
			'class': 'map'
		}).inject(this._monitor);

		self.remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function onSuccess() {
				var data = this.get_data();

				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function onMapReady() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});
	}
});
'use strict';

var BlimpExtMap = new Class({
	Extends: BlimpExt,

	post_process: function post_process() {
		var title = this._link.getAttribute('data-title');
		if (this._element.getElement('.map_title')) this._element.getElement('.map_title').set('html', title);

		if (!this.map) {
			this.create_map();
		}

		//this.addEvent('hide', this.self_destruct.bind(this));

		this.parent();
	},

	create_map: function create_map() {
		var self = this;
		var rpc = this._link.getAttribute('data-rpc-map');
		var _map_container = this._element.getElement('.map_container');

		_map_container.empty();

		var _map = new Element('div', {
			'class': 'map'
		}).inject(_map_container);

		self.remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function onSuccess() {
				var data = this.get_data();
				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function onMapReady() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});
	},

	self_destruct: function self_destruct() {
		Core.destruct(this.remote, this);
		Core.destruct(this.map, this);
	}
});
'use strict';

var BlimpExtPhotogallery = new Class({
	Extends: BlimpExt,
	options: {
		gallery_cls: 'w_photogallery',
		width_by_thumbs: 5,
		add_change_mode_options: false,
		data: null
	},

	post_process_build: function post_process_build() {
		var self = this;

		if (!this.photogallery) {
			var opts = this.options;
			var fp_data;
			this.data = this.data || this.options.data;

			if (this._element.getElement('.w_popup').hasClass('floorplan') && this.data.floorplan) {
				fp_data = {
					photos: this.data.floorplan && this.data.floorplan.length > 0 ? this.data.floorplan : this.data.photos,
					content: this.data.content
				};
			}

			var _phg = this._element.getElement('.' + opts.gallery_cls);
			this.photogallery = new PagePhotogallery(_phg, {
				data: fp_data ? fp_data : this.data,
				thumbs_amount: opts.width_by_thumbs,
				no_fullscreen_opt: false,
				add_change_mode_options: opts.add_change_mode_options,
				missing_img: Res_i + '/l/missing_grey_new_gallery_big_v2.png',
				width_image: 728,
				height_image: 490,
				onAddChangeModeOptions: function onAddChangeModeOptions() {
					self.add_links();
				}
			});

			this.photogallery.popup = this;
		}

		this.parent();

		if (!this.first_load) {
			this.set_default_gallery();
		}
		this.copy_contact_link_to_ad_name();

		this.first_load = false;
	},
	copy_contact_link_to_ad_name: function copy_contact_link_to_ad_name() {
		var _name = this._element.getElement('.w_popup .name');
		var _link = this._element.getElement('.w_popup .box .website a');
		if (_name && _link) {
			var link = _link.clone();
			_name.adopt(link);
			_link.dispose();
		}
	},

	add_links: function add_links() {
		var _link_container = this._element.getElement('.link_container');

		if (!_link_container || !_link_container.hasClass('_for_listing')) return;

		this._mp_link = _link_container.getElement('.map_view');
		this.for_floorplan = this._element.getElement('.w_popup').hasClass('floorplan');

		if (!this._mp_link && this.data.photos && this.data.photos.length == 0 || this.data.floorplan && this.data.floorplan.length == 0) {
			_link_container.dispose();
		} else {
			if (this.data.floorplan && this.data.floorplan.length > 0) {
				this._fp_link = new Element('a', {
					'href': '#',
					// 'text': 'View Floorplan',
					'html': '<i class="icon-floorplan big"></i><span class="link-label">View Floorplan</span>',
					'class': 'floorplan ' + (this.for_floorplan ? '_active' : '')
				}).inject(_link_container, 'top');
			}

			if (this.data.photos && this.data.photos.length > 0) {
				this._pg_link = new Element('a', {
					'href': '#',
					// 'text': 'View Photo Gallery',
					'html': '<i class="fa fa-camera big"></i><span class="link-label">View Photo Gallery</span>',
					'class': 'photogallery ' + (!this.for_floorplan ? '_active' : '')
				}).inject(_link_container, 'top');
			}
		}

		this.add_links_functionality();
	},

	add_links_functionality: function add_links_functionality() {
		var _fp, _pg, _mp;

		this._monitor = this._element.getElement('.photogallery_container');
		this.status_view = !this.for_floorplan ? 'pg' : 'fp';

		if (this._fp_link) {
			var fp_data = {
				photos: this.data.floorplan,
				content: this.data.content
			};

			this._fp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'fp') return;

				if (this.status_view == 'pg') {
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if (_pg) _pg.dispose();

				if (_mp) _mp.dispose();

				if (!_fp) {
					this.initialize_gallery(this._monitor, fp_data);
					_fp = this._monitor.getElement('.w_photogallery');
				} else {
					this._monitor.adopt(_fp);
				}

				if (this._pg_link) this._pg_link.removeClass('_active');

				if (this._mp_link) this._mp_link.removeClass('_active');

				this._fp_link.addClass('_active');
				this.status_view = 'fp';
			}.bind(this));
		}

		if (this._pg_link) {
			this._pg_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'pg') return;

				if (this.status_view == 'fp') {
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if (_fp) _fp.dispose();

				if (_mp) _mp.dispose();

				if (!_pg) {
					this.initialize_gallery(this._monitor, this.data);
					_pg = this._monitor.getElement('.w_photogallery');
				} else {
					this._monitor.adopt(_pg);
				}

				if (this._fp_link) this._fp_link.removeClass('_active');

				if (this._mp_link) this._mp_link.removeClass('_active');

				this._pg_link.addClass('_active');
				this.status_view = 'pg';
			}.bind(this));
		}

		if (this._mp_link) {
			this._mp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'mp') return;

				if (!_mp) {
					if (!_pg && !this.for_floorplan) {
						_pg = this._monitor.getElement('.w_photogallery');
					} else if (!_fp) {
						_fp = this._monitor.getElement('.w_photogallery');
					}

					_mp = this.initialize_map();
				} else {
					this._monitor.adopt(_mp);
				}

				if (_pg) _pg.dispose();

				if (_fp) _fp.dispose();

				if (this._pg_link) this._pg_link.removeClass('_active');

				if (this._fp_link) this._fp_link.removeClass('_active');

				this._mp_link.addClass('_active');
				this.status_view = 'mp';
			}.bind(this));
		}
	},

	set_default_gallery: function set_default_gallery() {
		if (!this._pg_link && !this._fp_link) return;

		if (this.for_floorplan) {
			this._fp_link.fireEvent('click');
		} else {
			this._pg_link.fireEvent('click');
		}
	},

	initialize_gallery: function initialize_gallery(_element, data) {
		this.floorplangallery = new PagePhotogallery(_element, {
			data: data,
			thumbs_amount: this.options.width_by_thumbs,
			no_fullscreen_opt: false,
			missing_img: Res_i + '/l/missing_grey_new_gallery_big_v2.png',
			width_image: 728,
			height_image: 490
		});
	},

	initialize_map: function initialize_map() {
		var self = this;
		var rpc = this._mp_link.getAttribute('data-rpc-map');
		var _map = new Element('div', {
			'class': 'map_container'
		}).inject(this._monitor);

		self.remote = new Remote({
			rpc: rpc,
			onSuccess: function onSuccess() {
				var data = this.get_data();

				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function onMapReady() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});

		return _map;
	}
});
'use strict';

var BuildingTours = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_building_tours',
		selector_position: 'top' //can be 'top' or 'overlap'
	},

	initialize: function initialize(element, options) {
		this._element = element || document.getElement('.' + this.options.cls);

		if (!this._element) return;

		this.build();
	},

	build: function build() {
		var self = this;

		Core.add_froogaloop();

		this._imagestrip = this._element.getElement('.w_imagestrip');
		this._bld_content = this._element.getElement('.bld_content');

		if (this._imagestrip) {
			this._istrip_container = this._imagestrip.getElement('.w_imagestrip_scroller');
			this._bld_content.addClass('loading');
		}

		var _select = this._element.getElement('.w_styled_select select');

		if (_select) {
			var _select_options = _select.getElements('option');

			_select.addEvent('change', function (_el) {
				$(document.body).setStyle('cursor', 'wait');

				self.inject_imagestrip(_el);
			});

			this._element.getElements('.w_styled_select .option').each(function (_option, i) {
				if (_option.hasClass('selected')) {
					_select.fireEvent('change', _select_options[i]);
				}
			});
		}

		this._element.getElements('.bld_info [data-url]').each(function (_el) {
			var url = _el.getAttribute('data-url');

			if (url != '') {
				_el.addEvent('click', function () {
					window.location = url;
				});
			}
		});

		this.add_selector_toggle();
	},

	inject_imagestrip: function inject_imagestrip(_el) {
		if (!_el || !this._istrip_container) return;

		var rpc = _el.getAttribute('data-rpc');

		if (!rpc || rpc == '') return;

		var self = this;

		new Remote({
			rpc: rpc,
			onSuccess: function onSuccess(data) {
				var _new_istrip = self._imagestrip.clone();

				_new_istrip.inject(self._imagestrip, 'after');
				self._imagestrip.dispose();
				self._imagestrip = _new_istrip;
				self._istrip_container = self._imagestrip.getElement('.w_imagestrip_scroller');
				self._istrip_container.set('html', this.get_data().content);

				new Imagestrip(self._imagestrip, {
					auto_move: false,
					amount: 5
				});

				self.process_imgs();
			}
		});
	},

	process_imgs: function process_imgs() {
		var self = this;
		var _imgs = this._imagestrip.getElements('.w_imagestrip_photo');

		_imgs.each(function (_el) {
			self.center_img(_el);

			_el.addEvents({
				'click': function click() {
					var _active_imgs = self._imagestrip.getElement('.w_imagestrip_photo.selected');

					if (_active_imgs) {
						_active_imgs.removeClass('selected');
					}

					_el.addClass('selected');

					var rpc = _el.getProperty('data-rpc');
					self._bld_content.set('html', '');
					self._bld_content.addClass('loading');

					new Remote({
						rpc: rpc,
						onSuccess: function onSuccess() {
							self._bld_content.set('html', this.get_data().content);
							self._bld_content.removeClass('loading');
							self.first_time_close = true;

							self.get_player();

							document.getElements('.bld_info [data-url]').each(function (_el) {
								var url = _el.getAttribute('data-url');

								if (url != '') {
									_el.addEvent('click', function () {
										window.location = url;
									});
								}
							});
						}
					});
				}
			});
		});

		_imgs[0].fireEvent('click');

		$(document.body).setStyle('cursor', 'default');
	},

	center_img: function center_img(_el) {
		var _img = _el.getElement('img');
		var src = _img.getProperty('src');

		new Asset.image(src, {
			onLoad: function onLoad() {
				var ml = (_el.getSize().x - _img.getSize().x) / 2;
				_img.setStyle('margin-left', ml);
			}
		});
	},

	add_selector_toggle: function add_selector_toggle() {
		var _selector = this._element.getElement('.' + this.options.cls + '_selector');
		var _toggle = this._element.getElement('.w_opener .toggle');

		if (!_selector || !_toggle) return;

		if (this.options.selector_position == 'overlap') {
			this.opener = new Opener(_toggle, _selector, {
				close_ability: true
			});

			_toggle.fireEvent('click');
		} else {
			this._element.addClass('_selector_no_hide');
		}
	},

	get_player: function get_player() {
		var _iframe = this._bld_content.getElement('iframe');

		if (!_iframe) return;

		this.player = Froogaloop(_iframe);
		this.player.addEvent('ready', this.handle_ready.bind(this));
	},

	handle_ready: function handle_ready() {
		this.player.addEvent('playProgress', this.handle_play.bind(this));
	},

	handle_play: function handle_play() {
		if (this.first_time_close && this.opener && this.opener.open) {
			this.opener.close_cnt();
			this.first_time_close = false;
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var FsMap = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_fsmap',
		type: null
	},

	initialize: function initialize(options) {
		this.setOptions(options);

		this.build();
	},

	build: function build() {
		var opts = this.options,
		    self = this;

		this._element = new Element('div', { 'class': opts.cls + ' ' + opts.type });
		this._fsmap_cont = new Element('div', { 'class': opts.cls + '_cont', 'html': '<div class="' + opts.cls + '_header"><h3 class="title">' + document.getElement('.page_title h1').get('text') + '</h3></div><div class="w_fsmap_map"><div class="map"></div></div>' }).inject(this._element);

		this._veil = new Element('.w_fsmap_veil').inject(this._fsmap_cont);

		var events = {};

		events['click:relay(.' + opts.cls + '_link)'] = function (e, _el) {
			if (e && e.stop) e.stop();

			self.clicked_element = _el;

			_gaq.push(['_trackEvent', _el.getAttribute('data-track-category'), _el.getAttribute('data-track-action'), _el.getAttribute('data-track-label')]);

			(function () {
				self.open_map();
			}).delay(50);
		};

		events['keydown'] = function (e) {
			if (e.code == 27) {
				//esc key
				self.close_map();
			}
		};

		document.addEvents(events);
	},

	open_map: function open_map() {
		this._element.setStyles({
			'visibility': 'hidden',
			'opacity': 0
		});

		this._element.inject(document.body);
		this._element.fade('in');

		if (!this.map) {
			this.load_map();
		}

		Cookie.write('sr_view', 'map', { duration: 1 });

		this.fireEvent('openMap');
	},

	close_map: function close_map() {
		this._element.fade('out');

		(function () {
			this._element.dispose();
		}).bind(this).delay(1000);

		Cookie.write('sr_view', 'list', { duration: 1 });

		this.fireEvent('closeMap');
	},

	load_map: function load_map() {
		var self = this;
		this._fsmap_cont.addClass('_loading');

		var _map = this._fsmap_cont.getElement('.map');

		this.map = new SimpleMap(_map, {
			zoom_control_style: 'small',
			max_zoom: 17,
			min_zoom: 10,
			onMapReady: function onMapReady() {
				self.fireEvent('mapReady');
			}
		});
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var Highstock = new Class({
	Implements: [Events, Options],

	options: {
		colors: ['#6aade1', '#aca000', '#008c99', '#c03e62', '#494a66', '#ff6a00'],

		containerId: null,

		chart: {
			chart: {
				renderTo: 'chart_container'
			},

			rangeSelector: {
				selected: 5,

				inputStyle: {
					color: '#355672',
					// fontWeight: 'bold',
					fontSize: '13px'
				},

				inputDateFormat: '%m/%d/%Y',
				inputEditDateFormat: '%m/%d/%Y'
			},

			credits: {
				enabled: false
			},

			xAxis: {
				ordinal: false,
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14 //two weeks
			},

			yAxis: {
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					align: 'left',
					x: 0
				},

				min: 0,
				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				endOnTick: false,
				showLastLabel: true,
				opposite: false
			},

			navigator: {
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 150,
					ordinal: false,
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					}
				},

				series: {
					color: '#008C99'
				}
			},

			plotOptions: {
				series: {
					animation: true
				},

				line: {
					dataGrouping: {
						enabled: false,
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			scrollbar: {
				barBackgroundColor: '#008C99',
				rifleColor: '#fff',
				buttonBackgroundColor: '#008C99',
				buttonArrowColor: '#fff'
			}
		},

		tooltip_title: null
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);

		this._element = element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var x_label = this._element.getAttribute('data-x-label');
		var y_label = this._element.getAttribute('data-y-label');

		if (x_label && x_label.trim() != '') {
			this.options.chart.xAxis.title.text = x_label;
		}

		if (y_label && y_label.trim() != '') {
			this.options.chart.yAxis.title.text = y_label;
		}

		this._chart_options = document.getElements('.chart_options li');
		this._veil = this._element.getElement('.veil');

		var rpc;
		this.series_options = new Array(this._chart_options.length);

		if (this._chart_options) {
			this._chart_options.each(function (_el, i) {
				if (!_el.hasClass('disabled')) {
					_el.setStyles({
						'color': this.options.colors[i],
						'border-color': this.options.colors[i]
					});
				}
			}.bind(this));

			this.rpcs = [];
			this._chart_options.each(function (e) {
				this.rpcs.push(e.getAttribute('data-rpc'));
			}.bind(this));

			rpc = this.rpcs[0];

			this._chart_options.each(function (e, i) {
				if (!e.hasClass('disabled')) {
					e.addEvent('click', function () {
						if (!e.hasClass('selected')) {
							if (this.waiting) return;

							document.body.style.cursor = 'wait';
							var rpc = e.getAttribute('data-rpc');

							if (rpc && rpc !== '') {
								this.add_series_option(e, i);
							} else {
								this.show_warning();
							}
						} else {
							this.hide_series_option(i);

							e.setStyles({
								'color': this.options.colors[i],
								'background-color': '#fff'
							});
						}
					}.bind(this));
				} else {
					e.addClass('inactive');
				}
			}.bind(this));
		}

		rpc = rpc || this._element.getAttribute('data-rpc');

		if (rpc && rpc !== '') {
			this.rpc_request(rpc, this.post_rpc.bind(this));
		}
	},

	rpc_request: function rpc_request(url, success) {
		var self = this;

		if (this._veil) {
			this._veil.show();
		}

		this.remote = new Remote({
			rpc: url,
			method: 'get',
			onSuccess: success,
			onError: function onError() {
				self.show_warning(true);
			}
		});
	},

	show_warning: function show_warning(permanent_msg) {
		if (!this._err_msg) {
			this._err_msg = new Element('div', { 'class': 'err_msg', 'text': 'No data available. Please try again later.' });
			this._err_msg.inject(this._element, 'before');
		}

		this._err_msg.fade('in');

		if (!permanent_msg) {
			(function () {
				this._err_msg.fade('out');
			}).bind(this).delay(3000);
		}

		this.fireEvent('warning');
	},

	add_series_option: function add_series_option(option, i) {
		var name = option.get('text');

		if (!this.series_options[i]) {
			this.waiting = true;

			this.rpc_request(option.getAttribute('data-rpc'), function () {
				this.series_options[i] = {
					name: name,
					data: this.remote.get_data().data,
					color: this.options.colors[i]
				};

				if (this.chart) {
					this.chart.addSeries(this.series_options[i]);
				}

				option.setStyles({
					'color': '#fff',
					'background-color': this.options.colors[i]
				});

				option.addClass('selected');

				if (this._veil) {
					this._veil.hide();
				}

				this.waiting = false;
			}.bind(this));
		} else {
			this.chart.addSeries(this.series_options[i]);
			option.addClass('selected');

			option.setStyles({
				'color': '#fff',
				'background-color': this.options.colors[i]
			});

			if (this._veil) {
				this._veil.hide();
			}

			this.waiting = false;
		}

		document.body.style.cursor = 'default';
	},

	hide_series_option: function hide_series_option(i) {
		var name = this.series_options[i].name,
		    position;

		if (this.chart) {
			this.chart.series.each(function (e, i) {
				if (e.name === name) position = i;

				return;
			});

			this.chart.series[position].remove();
		}

		this._chart_options[i].removeClass('selected');
	},

	post_rpc: function post_rpc() {
		var data = this.remote.get_data();
		this.sales = this.remote.get_data().sales;

		if (data && data.data && this.remote.get_data().data.length > 1) {
			this.series_options[0] = {
				name: 'All Transactions',
				data: this.remote.get_data().data,
				color: this.options.colors[0]
			};

			if (this._chart_options) {
				this._chart_options[0].addClass('selected');

				this._chart_options[0].setStyles({
					'color': '#fff',
					'background-color': this.options.colors[0]
				});
			}

			this.create_chart();
		} else {
			this._chart_options.getParent().hide();
			this.show_warning(true);
		}

		if (this._veil) {
			this._veil.hide();
		}

		this.waiting = false;
	},

	create_chart: function create_chart() {
		var self = this;
		var series_options = this.series_options.clean();
		var chart_options = this.options.chart;
		var data_type = this.get_data_type();
		var _container = null;
		if (this.options.containerId) {
			_container = document.getElement('#' + this.options.containerId);
		} else {
			_container = document.getElement('.w_bldblimp #chart_container');
		}

		if (!_container) {
			_container = this._element.getElement('#chart_container');
		}

		this.move_rangeselector();

		chart_options = Object.merge(chart_options, {
			chart: {
				renderTo: _container
			},

			series: series_options,

			tooltip: {
				useHTML: true,
				style: {
					padding: '8px'
				},
				formatter: function formatter(e) {
					if (self.sales) {
						var data = self.sales[this.x];
						var content = '';
						var color = this.points[0].series.color;

						var counter = 0;
						Object.each(data, function (row, i) {
							content += row[0];
							if (counter < Object.getLength(data) - 1) {
								content += '<br /><hr style="margin: 10px 0; color: ' + color + ';" />';
							}
							counter++;
						});
					} else {
						var pageTitle = document.getElement('.page_title h1') ? document.getElement('.page_title h1').get('text') : '';
						var _title = self.options.tooltip_title || pageTitle;
						var total_points = this.points.length;
						var content = '';
						content += '<div class="series_name" style="border-bottom-color:' + this.points[0].series.color + '">' + _title + '</div><br/>' + 'Value on ' + '<b>' + Highcharts.dateFormat('%b %e, %Y', this.x) + '</b><br/><br/>';

						if (total_points > 1) {
							content += data_type + ' price / ft<sup>2</sup> of : <br/>';
						}

						this.points.each(function (e, i) {
							var point = e.point;
							var amount = e.point.series.options.data[e.point.index][2] ? ' (' + e.point.series.options.data[e.point.index][2] + ')' : '';

							if (total_points > 1) {
								content += '<span style="color:' + point.series.color + '; margin-left:20px;">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							} else if (self._element.getAttribute('data-price-type') == 'closing') {
								content += data_type + ' closing price of <span style="color:' + point.series.color + '">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							} else {
								content += data_type + ' price / ft<sup>2</sup> of <span style="color:' + point.series.color + '">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							}
						});
					}

					return content;
				}
			},

			yAxis: {
				labels: {
					formatter: function formatter() {
						return '$' + Core.add_commas(this.value);
					}
				}
			}
		});

		this.chart = new Highcharts.StockChart(chart_options, function (chart) {
			setTimeout(function () {
				var _input_group = this._element.getElement('.highcharts-input-group');
				var _inputs = this._element.getElements('input.highcharts-range-selector', '#' + chart.options.chart.renderTo);

				if (_input_group) {
					// this is a workaround. close event from Date Picker widget is triggerred when clicking the input Date
					// need to cancel it.
					_input_group.addEvent('click', function (e) {
						e.stop();
					});
				}

				if (_inputs && _inputs.length > 1) {
					var min_date = new Date().parse(_inputs[0].get('value'));
					var max_date = new Date().parse(_inputs[1].get('value'));
				}

				_inputs.each(function (_el, i) {
					var min = min_date.clone();
					var max = max_date.clone();

					var dp = new Picker.Date(_el, {
						timePicker: true,
						draggable: false,
						minDate: i === 0 ? min : min.increment('day', 15),
						maxDate: i === 1 ? max : max.decrement('day', 15),
						pickOnly: 'days',
						pickerClass: 'datepicker_vista',
						format: "%Y-%m-%d",
						useFadeInOut: true,
						onSelect: function onSelect(dateText, input) {
							input.onchange();
							input.onblur();

							if (i === 0) {
								datepickers[1].options.minDate = dateText.increment('day', 15);
							} else if (i === 1) {
								datepickers[0].options.maxDate = dateText.decrement('day', 15);
							}
						}
					});

					datepickers.push(dp);

					_el.addEvent('focus', function () {
						datepickers.each(function (dp, j) {
							if (i !== j) {
								dp.hide();
							}
						});
					});
				});
			}.bind(this), 0);
		}.bind(this));
	},

	get_data_type: function get_data_type() {
		var rpc_string = this.remote.options.rpc;
		var p = rpc_string.contains('&p=');
		var show = rpc_string.contains('&show');

		if (p || show) {
			if (p) {
				data_type = 'Median';
			}

			if (show) {
				var rpc_string = this.remote.options.rpc;
				var start = rpc_string.indexOf('show');
				var end = rpc_string.lastIndexOf('&');
				var show_param = rpc_string.substring(start, end);
				var data_type = show_param.substring(show_param.indexOf('=') + 1);

				data_type = data_type == 'avg' ? 'Average' : 'Median';
			}

			return data_type;
		}

		data_type = 'Average';

		return data_type;
	},

	move_rangeselector: function move_rangeselector() {
		// To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 10
				});

				leftPosition += this.zoomText.getBBox().width + 20;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	}
});

var datepickers = [];
'use strict';

var ManagementCompanyGallery = new Class({
	Implements: [Options, Events],

	options: {
		cls: 'w_management_company_gallery',
		region_result_max_items: 2,
		type: 'listing'
	},

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		var cls = this.options.cls,
		    fcls = '.' + cls;

		this.first_load = true;
		this._filter = this._element.getElement(fcls + '_filter');
		this._real_state_comp = this._filter.getElement('.real_state_comp');
		this._stage = this._element.getElement(fcls + '_stage');
		this._info = this._stage.getElement('.info');
		this._veil = this._stage.getElement('.veil');
		this.photogallery_template = this._stage.getElement('.box') ? this._stage.getElement('.box').get('html') : '';

		this.get_real_estate_companies();
	},

	run_js: function run_js() {
		this.create_company_filter();
		this.add_real_state_option_finctionality();
		this.add_close_functionality();
		this.add_buildings_functionality();

		this.set_initial_item();
	},

	get_real_estate_companies: function get_real_estate_companies() {
		var self = this;
		var rpc = this._element.get('data-company-rpc');

		if (rpc) {
			new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					self.data = this.get_data();

					if (!self.data || self.data.length == 0) return;

					self.run_js();
				}
			});
		}
	},

	create_company_filter: function create_company_filter() {
		var data = this.data;
		var _imagestrip = this._real_state_comp.getElement('.w_imagestrip');
		var _imagestrip_images_container = _imagestrip.getElement('.w_imagestrip_images_container');
		this._companies = [];

		Object.each(data, function (el, i) {
			var _photo = new Element('div', {
				'class': 'w_imagestrip_photo',
				'data-rpc': el.rpc,
				'html': '<div class="w_imagestrip_image">' + '<img src="' + el.logo_url + '">' + '</div>'
			});

			_photo.data = el;
			_photo.inject(_imagestrip_images_container);
			this._companies.push(_photo);
		}.bind(this));

		new Imagestrip(_imagestrip, {
			auto_move: false,
			amount: 1,
			display_items: 5
		});
	},

	create_region_list: function create_region_list(_company) {
		var region_list = '';

		Object.each(_company.data.regions, function (region, i) {
			region_list += '<li data-region-id="' + i + '" data-company-id="' + _company.data.id + '">' + region + '</li>';
		});

		var content = '<div class="main_select clearfix">' + '<ul class="options clearfix" data-rpc="' + _company.data.rpc + '">' + region_list + '</ul>' + '<a href="#previous" class="side_options_btn_previous">Previous</a>' + '<a href="#next" class="side_options_btn_next">Next</a>' + '</div>' + '<div class="main_container">' + '<div class="veil">&nbsp;</div>' + '</div>';

		_company._regions = new Element('div', {
			'class': 'regions w_side_options _comp_' + _company.data.id,
			'html': content
		}).inject(this._filter);

		_company._regions_main_cont = _company._regions.getElement('.main_container');

		this.add_regions_functionality(_company);
	},

	add_real_state_option_finctionality: function add_real_state_option_finctionality() {
		this._companies.each(function (_company, i) {
			_company.addEvents({
				'click': function () {
					if (this._active_real_state) {
						this._active_real_state.removeClass('_active');
						this._active_real_state._regions.hide();
					}

					_company.addClass('_active');
					this._active_real_state = _company;

					if (!_company.regions_initialized) {
						this.create_region_list(_company);
					} else {
						_company._regions.show();
					}

					if (!this.first_load) {
						this.show_region_content();
					}
				}.bind(this)
			});
		}.bind(this));
	},

	add_regions_functionality: function add_regions_functionality(_company) {
		var self = this;

		_company._regions.getElements('li').each(function (_region) {
			_region.addEvents({
				'click': function () {
					if (!this.first_load) {
						this.show_region_content();
					}
				}.bind(this)
			});
		}.bind(this));

		this.sideOptions = new SideOptionsExt(_company._regions, {
			initial_option: 0,
			minimum_row: 1,
			maximum_row: this.options.region_result_max_items,
			with_pagination: true,
			by_region: true,
			'onSuccess': function onSuccess() {
				if (self.first_load) {
					self._selected_building = self._active_real_state._regions.getElement('._item');
					self._selected_building._company = self._active_real_state;

					if (self.options.type == 'building') {
						self.get_building_content(self._selected_building);
					} else {
						self.show_listings(self._selected_building);
					}

					self._selected_building.addClass('_selected');
					self.first_load = false;
					self.hide_region_content();
				}
			}
		});

		_company.regions_initialized = true;
	},

	add_buildings_functionality: function add_buildings_functionality() {
		var self = this;

		this._element.addEvents({
			'click:relay(._item)': function (e, _el) {
				if (_el.hasClass('_selected') || _el.hasClass('_empty')) {
					return;
				}

				if (this._selected_building) {
					this._selected_building.removeClass('_selected');
				}

				this._stage.getElement('.veil').show();
				this._veil.show();

				(function () {
					if (this.options.type == 'building') {
						if (!_el.content) {
							self.get_building_content(_el);
						} else {
							self.show_building(_el);
						}
					} else {
						this.show_listings(_el);
					}
				}).delay(1000, this);

				_el.addClass('_selected');
				this._selected_building = _el;
				this._selected_building._company = this._active_real_state;

				this.hide_region_content();
			}.bind(this)
		});
	},

	set_initial_item: function set_initial_item() {
		this._active_company = this._real_state_comp.getElements('.w_imagestrip_photo')[0];

		if (this.first_load) {
			this._active_company.fireEvent('click');

			this._veil.show();
		}
	},

	show_building: function show_building(_el) {
		this._veil.hide();
		this._stage.set('html', _el.content);

		var _photogallery = this._stage.getElement('.w_photogallery');
		if (_photogallery) {
			_el.gallery = new Photogallery(_photogallery, {
				width_by_thumbs: 0
			});
		}
	},

	show_listings: function show_listings(_el) {
		//_el.data was assign in SideoptionsExt widget

		if (!_el) return;

		if (!_el.gallery) {
			this._stage.getElement('.box').set('html', this.photogallery_template);

			var building = _el.data;

			Object.each(building.data, function (el) {
				var _thumb = new Element('div', {
					'class': 'thumb',
					'data-full': el.image_full,
					'html': '<div class="thumb_veil">&nbsp;</div>' + '<img ' + 'src="' + el.image + '" ' + 'title="' + el.building_name + ', #' + el.unit + '" ' + 'alt="' + el.building_name + ', #' + el.unit + '" ' + '/>'
				});

				_thumb.data = el;
				_thumb.inject(this._stage.getElement('.w_photogallery_strip'));
			}.bind(this));
		}

		var _photogallery = this._stage.getElement('.w_photogallery');

		if (_photogallery) {
			_el.gallery = new Photogallery(_photogallery, {
				width_by_thumbs: 0
			});
		}

		this.handle_navigation_click();
		this.update_info_section();
		this._veil.hide();
	},

	get_building_content: function get_building_content(_el) {
		var self = this;
		var rpc = this._element.get('data-building-rpc') + '?t=' + _el.building_id.toString();

		new Remote({
			rpc: rpc,
			onSuccess: function onSuccess() {
				_el.content = this.get_data().content;

				if (!_el.content) return;

				self.show_building(_el);
			}
		});
	},

	add_close_functionality: function add_close_functionality() {
		document.addEvents({
			'click': function (e) {
				if (e && e.target && (e.target.getParent('.' + this.options.cls) === this._element || e.target === this._element)) {
					return;
				}

				if (this._selected_building && this._selected_building._company) {
					this._selected_building._company.fireEvent('click');
				}

				this.hide_region_content();
			}.bind(this)
		});
	},

	handle_navigation_click: function handle_navigation_click() {
		this._stage.getElements('.w_photogallery_arrow_previous, .w_photogallery_arrow_next').each(function (_el) {
			_el.addEvent('click', function () {
				this.update_info_section();
			}.bind(this));
		}.bind(this));
	},

	update_info_section: function update_info_section() {
		var template = '';
		var _current_thumb = this._stage.getElement('.thumb.current');

		if (_current_thumb) {
			var data = _current_thumb.data;

			template += '<h1><a href="{url_listing}">{building_address}, # {unit}</a></h1>' + '<ul class="">' + '<li><span>' + (data.bedrooms ? '{bedrooms}' : '') + (data.bathrooms ? ', ' + '{bathrooms}' : '') + '&nbsp;</span></li>' + (data.price ? '<li>| <strong>{price}</strong></li>' : '') + '</ul>' + (data.description ? '<div class="description">{description}</div>' : '') + '<a class="button raquo" href={url_listing}>View Full Listing Info</div>';

			template = template.substitute(data);
			this._info.set('html', template);
		}
	},

	show_region_content: function show_region_content() {
		this._active_real_state._regions_main_cont.show();
		this._active_real_state._regions.setStyle('height', 'auto');

		if (this.sideOptions._pagination) {
			this._active_real_state._regions.getElement('.side_options_btn_previous').show();
			this._active_real_state._regions.getElement('.side_options_btn_next').show();
		}
	},

	hide_region_content: function hide_region_content() {
		this._active_real_state._regions_main_cont.hide();
		this._active_real_state._regions.getElement('.side_options_btn_previous').hide();
		this._active_real_state._regions.getElement('.side_options_btn_next').hide();
	}
});
'use strict';

var MapView = new Class({
	Implements: [Events, Options],

	options: {
		auto_open: false,
		back_button: true,
		counts_only: false,
		icon_path: null,
		with_hover_icon: true,
		with_filter: false,
		filter_param: '',
		add_class: null
	},

	initialize: function initialize(options) {
		this.setOptions(options);

		if (this.options.auto_open) {

			this._click_el = document.getElement('.forced_map');

			if (!this._click_el) return;

			this.create_map();

			if (_gaq) {
				_gaq.push(['_trackEvent', this._click_el.getAttribute('data-track-category'), this._click_el.getAttribute('data-track-action'), this._click_el.getAttribute('data-track-label')]);
			}

			this.fs_map.open_map();
		} else {
			this.create_map();
		}

		if (this.options.back_button) {
			this.create_close_button();
		}
	},

	create_map: function create_map() {
		var self = this;
		var opts = this.options;
		var firstload = true;
		var sr_map;

		var __setMap = function __setMap() {
			var rpc;

			if (opts.auto_open) {
				rpc = self._click_el.get('data-rpc');

				if (self._click_el.getAttribute('data-type')) {
					rpc += '?type=' + self._click_el.getAttribute('data-type');
				}
			} else {
				rpc = fs_map.clicked_element.get('data-rpc');
			}

			if (sr_map) {
				sr_map.clear_regions();
			}

			sr_map = self.sr_map = new SearchResultsMap(fs_map.map, {
				is_building: true,
				counts_only: self.options.counts_only,
				data_rpc: rpc,
				icon_path: self.options.icon_path,
				with_hover_icon: self.options.with_hover_icon,

				onRequest: function onRequest(e) {
					fs_map._fsmap_cont.addClass('_loading');
				},

				onDataLoad: function onDataLoad(data) {
					fs_map._fsmap_cont.removeClass('_loading');

					// add the filter
					if (self.options.with_filter && data && data.tableTools && data.tableTools.filters && !self.hasFilter) {
						self.create_filter(data.tableTools.filters[0].options);
						self.hasFilter = true;
					}
				}
			});

			// add extra class
			if (self.options.add_class) {
				self.sr_map.map._element.addClass(self.options.add_class);
			}
		};

		var fs_map = this.fs_map = new FsMap({
			onMapReady: function onMapReady() {
				__setMap();
				firstload = false;
			},

			onOpenMap: function onOpenMap() {
				fs_map._fsmap_cont.addClass('_loading');
				fs_map.map.clear_markers();

				if (!firstload) {
					__setMap();
				}

				if (Stalker_instance) {
					if (Stalker_instance._element.hasClass('_down')) {
						Stalker_instance._element.removeClass('_down');
						Stalker_instance._element.previousState = 'down';
					} else {
						Stalker_instance._element.previousState = 'up';
					}

					Stalker_instance._element.addClass('_on_map_view');
					Stalker_instance._element.addClass('show_back_button');

					if (self.options.with_filter) {
						Stalker_instance._element.addClass('show_filter');
					}
				}

				fs_map._fsmap_cont.addEvent('mouseenter', function () {
					document.fireEvent('hideSubMenu');
				});

				fs_map.opened = true;

				self.resize_map();
			},

			onCloseMap: function onCloseMap() {
				if (Stalker_instance) {
					if (Stalker_instance._element.previousState === 'down') {
						Stalker_instance._element.addClass('_down');
					}
					Stalker_instance._element.removeClass('_on_map_view');
					Stalker_instance._element.removeClass('show_back_button');
					Stalker_instance._element.removeClass('show_filter');
				}

				if (sr_map && sr_map.current_big_bubble) {
					sr_map.current_big_bubble.close();
				}

				fs_map.opened = false;
			}
		});
	},

	create_close_button: function create_close_button() {
		var self = this;

		(function () {
			if (Stalker_instance && Stalker_instance._element) {
				var _close = new Element('.w_fsmap_close', {
					'html': '<span class="option gallery"><i class="fa fa-th-list fa18"></i><span>Gallery</span></span> <span class="devider">|</span> <span class="option active"><i class="fa fa-map-marker fa18"></i><span>Map</span></span>'
				});

				_close.inject(Stalker_instance._element);

				_close.getElement('.gallery').addEvent('click', function () {
					self.fs_map.close_map();
				});
			}
		}).delay(1000);
	},

	create_filter: function create_filter(options) {
		var self = this;
		var filter_array = [];

		if (options) {
			var li_options = '';
			options.each(function (option) {
				li_options += '<li data-value="' + option.value + '">' + option.label + '</li>';
			});

			var html = '<div class="header">filter By:<div class="clear_btn">clear filters</div></div><ul>' + li_options + '</ul>';

			var _filter = new Element('.w_fsmap_filter', {
				html: html
			});

			_filter.addEvents({
				'click:relay(li)': function clickRelayLi(e) {
					var filter_param = '';
					this.toggleClass('_active');

					if (this.hasClass('_active')) {
						// add it in the filter array
						filter_array.include(this.get('data-value'));
					} else {
						// remove from the filter array
						filter_array.erase(this.get('data-value'));
					}

					filter_array.each(function (item, i) {
						filter_param += (filter_param.length !== 0 ? '&' : '') + self.options.filter_param + '=' + item;
					});

					// set the filter parameters that will be use on SearchResultsMap widget
					self.sr_map.options.filter_param = filter_param;

					var region = self.sr_map.current_region;
					if (region) {
						// we have to reset selected hood to be able to send a new rpc with the filter
						region.is_active = false;
						region.gross_data = null;
						self.sr_map.handle_region_click(region, null, true);
					} else {
						self.sr_map.get_data();
					}
				},
				'click:relay(div.clear_btn)': function clickRelayDivClear_btn(e) {
					//update the map with no filters
					self.sr_map.current_region = null;
					self.sr_map.options.filter_param = null;
					self.sr_map.get_data();
					filter_array.empty();

					// reset the active filters
					_filter.getElements('li._active').each(function (_li) {
						_li.removeClass('_active');
					});
				}
			});

			_filter.inject(Stalker_instance._element);
		}
	},

	resize_map: function resize_map() {
		var self = this;
		var fs_map = this.fs_map;

		if (!fs_map.opened) return;

		var _header = fs_map._element.getElement('.w_fsmap_header');
		var _map = fs_map._element.getElement('.w_fsmap_map');

		if (!_map) return;

		if (_header) {
			var top = _header.getSize().y;

			if (Stalker_instance && Stalker_instance._element) {
				top = Stalker_instance._element.getSize().y;
			}

			_map.setStyle('top', top);
		}

		_map.getElement('.map').setStyle('height', _map.getSize().y);

		var map = fs_map.map.map;

		if (GoogleApiLoad == 'loaded' && map) {
			google.maps.event.trigger(map, 'resize');
		} else {
			(function () {
				self.resize_map();
			}).delay(500);
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.1: '*'
...
*/
var Opener = new Class({
	Implements: [Options, Events],
	options: {
		close_ability: false,
		no_toggler: false,
		animate: true
	},

	initialize: function initialize(toggler, toshow, options) {
		this.setOptions(options);

		if (this.options.no_toggler == false && toggler && toshow) {
			this._toggler = toggler;
			this._toshow = toshow;
			this.build();
		} else if (this.options.no_toggler == true && toshow) {
			this._toshow = toshow;
			this.build();
		}
	},

	build: function build() {
		this.pos = this._toshow.getStyle('position');

		if (this.options.no_toggler == false) {
			var rpc = this._toggler.getProperty('data-rpc');

			if (!rpc || rpc == '') {
				this._toggler.addEvent('click', this.toggle_cnt.bind(this));

				this.get_size();

				if (this._toggler.getProperty('type') && this._toggler.getProperty('type') != '') {
					this._toggler.addEvent('focus', this.toggle_cnt.bind(this));
				} else {
					var _input = this._toggler.getElement('input');

					if (_input) {
						_input.addEvent('focus', this.toggle_cnt.bind(this));
					}
				}
			} else {
				this._toggler.addEvent('click', function (e) {
					if (e && e.stop) e.stop();

					if (!this.remote && !this.data) {
						this.remote = new Remote({
							rpc: rpc,
							method: 'get',
							onSuccess: this.process_rpc.bind(this)
						});
					} else {
						this.fireEvent('ready');
						this.toggle_cnt();
					}
				}.bind(this));
			}
		} else {
			this.get_size();
		}
	},

	get_size: function get_size() {
		if (!this.options.animate) {
			this._toshow.hide();
			return;
		}

		this._toshow.setStyles({
			position: 'absolute',
			visibility: 'hidden',
			overflow: 'hidden'
		});

		this.margin_t = this._toshow.getStyle('marginTop').toInt();
		this.margin_b = this._toshow.getStyle('marginBottom').toInt();
		this.padding_t = this._toshow.getStyle('paddingTop').toInt();
		this.padding_b = this._toshow.getStyle('paddingBottom').toInt();
		this.height = this._toshow.getComputedSize().height - this.padding_t - this.padding_b - this.margin_t - this.margin_b;

		this._toshow.setStyles({
			position: this.pos,
			height: 0,
			marginTop: 0,
			marginBottom: 0,
			paddingTop: 0,
			paddingBottom: 0,
			visibility: 'visible'
		});
	},

	process_rpc: function process_rpc() {
		if (!this.data) this.data = this.remote.get_data();

		this.fireEvent('ready');

		this.get_size();
		this.toggle_cnt();
	},

	toggle_cnt: function toggle_cnt() {
		this.tween = new Fx.Morph(this._toshow, { duration: 300 });

		if (!this.open || this.open == false) {
			this.open_cnt();
		} else {
			this.close_cnt();
		}
	},

	open_cnt: function open_cnt() {
		if (this.open) return;

		if (!this.options.animate) {
			this._toshow.show();

			if (this._toggler) {
				this._toggler.addClass('active');
			}
		} else {
			this.tween.start({
				'marginTop': this.margin_t,
				'marginBottom': this.margin_b,
				'paddingTop': this.padding_t,
				'paddingBottom': this.padding_b,
				'height': this.height
			}).chain(function () {
				if (this._toggler) {
					this._toggler.addClass('active');
				}
			}.bind(this));

			(function () {
				this._toshow.setStyles({
					'height': 'auto',
					'overflow': 'visible',
					'display': 'block'
				});
			}).bind(this).delay(400);
		}

		this.open = true;
	},

	close_cnt: function close_cnt() {
		if (!this.open) return;

		if (!this.options.animate) {
			this._toshow.hide();
		} else {
			if (this.options.close_ability) {
				this._toshow.setStyles({
					'overflow': 'hidden',
					'height': this._toshow.getSize().y
				});

				this.tween.start({
					'marginTop': 0,
					'marginBottom': 0,
					'paddingTop': 0,
					'paddingBottom': 0,
					'height': 0
				});
			}
		}

		if (this._toggler) {
			this._toggler.removeClass('active');
		}

		this.open = false;
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Rater = new Class({
	Implements: [Events, Options],
	options: {
		max_size: 0, //height or width
		min_size: 0, //height or width === don't need to specify, if 'size' in this options is absolute
		max_data: 0, //max value through the elements === optional
		min_data: 0, //min value through the elements === optional
		property: 'data-height', //property of the elements where to take data
		animate: true,
		duration: 500,
		equal_speed: true, //if false, all animations will finish at the same time (duration),
		//if true, the speed for each animation is the same, so the smallest element will finish first
		transition: Fx.Transitions.linear,
		type: 'vertical', //vertical or horisontal
		size: 'absolute', //absolute or relative
		//IMPORTANT!: don't use 'relative' sizing if there is a possibility of negative values !!!!!!!!!!!!
		//if absolute, the size of each element counts from 0
		//i.e. - max_size is 100px,
		//and you have 5 elements with 'data-height's {20, 40, 60, 80, 100},
		//so, their sizes are going to be - {20, 40, 60, 80, 100}.
		//if relative, the size of each element counts from min_height
		//i.e. - max_size is 100px, min_size is 60px, and you have the same elements,
		//so, their sizes are going to be - {60, 70, 80, 90, 100}
		calculate_even_one_element: false //can be helpful when you use lazyLoader (in this case set to 'true')
	},

	initialize: function initialize(_elements, options) {
		this._elements = _elements;

		if (this._elements) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;

		if (this._elements.length == 0 || this._elements.length == 1 && !opts.calculate_even_one_element) return;

		this.max_data = opts.max_data;
		this.min_data = opts.min_data;
		this.has_negative = this.max_data < 0 || this.min_data < 0;

		if (opts.type == 'vertical') {
			this.max_size = opts.max_size == 0 ? this._elements[0].getSize().y : opts.max_size;
		} else {
			this.max_size = opts.max_size == 0 ? this._elements[0].getSize().x : opts.max_size;
		}

		if (this.max_size > 0) {
			opts.max_size = this.max_size;

			if (opts.animate == true) {
				if (opts.type == 'vertical') {
					this._elements.each(function (_el) {
						_el.setStyle('height', 0);
					});
				} else {
					this._elements.each(function (_el) {
						_el.setStyle('width', 0);
					});
				}
			}

			if (!this.max_data || this.max_data == 0) {
				this.get_values();
			}

			if (!(this.max_data == 0 && this.min_data == 0)) {
				this.calculate_size();
				this.set_size();
			}
		}
	},

	get_values: function get_values() {
		this._elements.each(function (_el) {
			var data = _el.getAttribute(this.options.property).toFloat() || 0;

			if (data > this.max_data) {
				this.max_data = data;
			}

			if (this.min_data > data || this.min_data == 0) {
				this.min_data = data;
			}

			if (data < 0) {
				this.has_negative = true;
			}
		}.bind(this));
	},

	calculate_size: function calculate_size() {
		var opts = this.options;

		if (this.options.size == 'relative') {
			var data_diff = this.max_data - this.min_data,
			    size_diff = opts.max_size.toInt() - opts.min_size.toInt();

			this._elements.each(function (_el) {
				var data = _el.getAttribute(opts.property).toFloat(),
				    this_size = opts.max_size;

				if (data_diff > 0) {
					this_size = opts.min_size + (data - this.min_data) * size_diff / data_diff;
				}

				_el.setAttribute('data-size', this_size);
			}.bind(this));

			if (this.min_data < 0) {
				console.warn("Don't use 'relative' sizing with negative values!");
			}
		} else {
			if (this.max_data > 0 && this.min_data >= 0) {
				this._elements.each(function (_el) {
					var data = _el.getAttribute(opts.property).toFloat();
					data = data > this.max_data ? this.max_data : data;

					var this_size = data * opts.max_size / this.max_data;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			} else if (this.max_data <= 0 && this.min_data < 0) {
				this._elements.each(function (_el) {
					var data = _el.getAttribute(opts.property).toFloat();
					data = data > this.max_data ? this.max_data : data;

					var this_size = data * opts.max_size / this.min_data * -1;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			} else if (this.max_data > 0 && this.min_data < 0) {
				var count_data = this.max_data + this.min_data * -1,
				    shift = this.min_data * opts.max_size / count_data * -1;

				if (opts.type == 'vertical') {
					this._elements.each(function (_el) {
						var _parent = _el.getParent();
						_parent.setStyle('height', _parent.getSize().y - shift);

						var data = _el.getAttribute(opts.property).toFloat();
						data = data > this.max_data ? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				} else {
					this._elements.each(function (_el) {
						var _parent = _el.getParent();

						_parent.setStyles({
							'margin-left': shift,
							'width': _parent.getSize().x - shift
						});

						var data = _el.getAttribute(opts.property).toFloat();
						data = data > this.max_data ? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				}
			}
		}
	},

	set_size: function set_size() {
		var _this = this;
		var opts = this.options;

		if (this.has_negative) {
			opts.animate = false;

			if (this.max_data <= 0) {
				this._elements.each(function (_el) {
					var _parent = _el.getParent();

					if (opts.type == 'vertical') {
						_parent.setStyle('height', 'auto');
					}
				}.bind(this));
			}
		}

		if (opts.animate == true) {
			this._elements.each(function (_el) {
				var size = _el.getAttribute('data-size').toFloat(),
				    this_time = opts.equal_speed == true ? size * opts.duration / opts.max_size : opts.duration,
				    animate = new Fx.Morph(_el, { duration: this_time, transition: opts.transition });

				if (opts.type == 'vertical') {
					animate.start({ 'height': [0, size] });
				} else {
					animate.start({ 'width': [0, size] });
				}

				(function () {
					animate = null;
				}).delay(this_time);
			});

			(function () {
				_this.fireEvent('animationDone');
			}).delay(opts.duration);
		} else {
			this._elements.each(function (_el) {
				var size = _el.getAttribute('data-size').toFloat(),
				    shift = 0;

				if (size < 0) {
					shift = size;
					size *= -1;
				}

				if (opts.type == 'vertical') {
					_el.setStyles({
						'height': size,
						'bottom': shift
					});
				} else {
					_el.setStyles({
						'width': size,
						'left': shift
					});
				}
			});
		}

		this.fireEvent('sizeSet');
	}
});
'use strict';

var SalesData = new Class({
	Implements: [Options, Events],

	options: {
		data: null,
		cls: 'w_sales_data',
		use_cookies: true,
		colors: {
			10: '#b19f00',
			11: '#018f9b',
			12: '#b4224a',
			13: '#484a67',
			14: '#ff5a00'
		},
		shorten_pricerange: false
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);
		this._element = _element || document.getElement('.' + this.options.cls);

		if (!this._element) return;

		this.build();
	},

	build: function build() {
		var self = this;

		this.beds_filter_applied = false;
		this.first_load = true;
		this.is_loaded = false;

		if (this.options.use_cookies) {
			window.addEvent('beforeunload', function (e) {
				// set the cookie only if the chart is initialized.
				if (self.is_loaded) {
					self.write_cookies();
				}
			});

			this.read_cookies();
		} else {
			this.cookies = {};
		}

		this._beds_filter = this._element.getElement('.beds_filter');

		this._veil = this._element.getElement('.veil');
		this._data_display = this._element.getElement('.data_display');
		this._chart = this._element.getElement('.chart');
		this._list = this._element.getElement('.list');

		this._chart.show = function () {
			if (self._element.hasClass('_list_view')) return;

			self._chart.removeClass('_hidden');
		};

		this._chart.hide = function () {
			self._chart.addClass('_hidden');
		};

		this._controllers = this._element.getElement('.data_controllers');

		this.new_currency = true;

		this.rpc = this.add_type_select();

		this.add_currency_select();
		this.add_period_select();
		this.add_beds_select();
		// this.add_listings_select();

		this.get_data();
	},

	add_type_select: function add_type_select() {
		var self = this;

		this._type_select = this._element.getElement('.type_select');

		if (!this._type_select) return;

		var _selected;

		if (this.cookies.type) {
			this._type_select.getElements('option').some(function (_el) {
				if (_el.getAttribute('data-type') == self.cookies.type) {
					_selected = _el;
					_el.fireEvent('select');
					return true;
				}
			});
		}

		this._type_select.addEvents({
			'change': function change(_el) {
				var data_rpc = _el.getAttribute('data-rpc');

				if (data_rpc) {
					self.rpc = data_rpc;
				}

				var _selected = self._type_select.getElement('._selected') || self._type_select.getElement('option:selected');

				if (_selected) {
					self._element.type = _selected.getAttribute('data-type');
				}

				self.get_data();
			}
		});

		_selected = _selected || this._type_select.getElement('._selected') || this._type_select.getElement('option:selected') || this._type_select.getElements('option')[0];

		this._element.type = _selected.getAttribute('data-type');

		return _selected.getAttribute('data-rpc');
	},

	add_currency_select: function add_currency_select() {
		var self = this;

		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		if (this.cookies.currency) {
			this._currency_select.getElements('option').some(function (_el) {
				if (_el.get('value') == self.cookies.currency) {
					_el.fireEvent('select');
					self.currency = _el.get('value');
					return true;
				}
			});
		}

		if (!this.currency) {
			var _selected = this._currency_select.getElement('option[selected]') || this._currency_select.getElement('option');
			this.currency = _selected.get('value');
		}

		this._currency_select.addEvent('change', function () {
			self.currency = self._currency_select.getElement(':selected').get('value');

			self._element.currency = {
				'id': self.currency,
				'symbol': self.data.currency_symbol
			};

			self.new_currency = true;
			self.get_data();
		});
	},

	add_period_select: function add_period_select() {
		var self = this;

		this._period_select = this._element.getElement('.w_styled_select.period select');

		if (this.cookies.period) {
			this._period_select.getElements('option').some(function (_el) {
				if (_el.get('value') == self.cookies.period) {
					_el.fireEvent('select');
					self.start_date = _el.get('value');
					return true;
				}
			});
		}

		if (!this.start_date) {
			var _selected = this._period_select.getElement('option[selected]') || this._period_select.getElement('option');
			this.start_date = _selected.get('value');
		}

		this._period_select.addEvent('change', function () {
			self.update_section_title();

			self.start_date = self._period_select.getElement(':selected').get('value');
			self.get_data();
		});

		self.update_section_title();
	},

	add_listings_select: function add_listings_select() {
		var self = this;

		this._listings_select = this._element.getElement('.w_styled_select._listings select');

		if (this.cookies.listings) {
			this._listings_select.getElements('option').some(function (_el) {
				if (_el.get('value') == self.cookies.listings) {
					_el.fireEvent('select');
					self.listings_type = _el.get('value');
					return true;
				}
			});
		}

		if (!this.listings_type) {
			var _selected = this._listings_select.getElement('option[selected]') || this._listings_select.getElement('option');
			this.listings_type = _selected.get('value');
		}

		this._listings_select.addEvent('change', function () {
			self.update_section_title();

			self.listings_type = self._listings_select.getElement(':selected').get('value');
			self.get_data();
		});

		self.update_section_title();
	},

	add_beds_select: function add_beds_select() {
		var self = this;

		//this._bed_select = this._element.getElement('.w_multiselect._beds select');

		this.beds_multiselect = new Multiselect(this._element.getElement('.w_multiselect._beds'), {
			text_input: false,
			close_button: false,
			equality: true,
			add_tiles: false,
			onClick: function onClick(e, _el) {

				Cookie.write('salesDataBedsClicked', true);

				if (!_el.hasClass('_active')) return;

				_el.toggleClass('_hover');
				self.filter_bedrooms(_el.getAttribute('data-id'));

				if (self._list.instance) {
					self._list.instance.update();
				}

				self.first_load = false;
			}
		});

		this.beds_multiselect.update_monitor();
	},

	update_section_title: function update_section_title() {
		var _section_title = this._element.getElement('.header h2 span');

		if (_section_title) {
			var _selected_period = this._period_select.getElement('option:selected') || this._period_select.getParent().getElement('.selected');
			_section_title.set('text', _selected_period.get('text').capitalize());
		}
	},

	get_data: function get_data() {
		var self = this;
		this._veil.show();

		if (this.remote) {
			this.remote.cancel();
		}

		if (this.options.data) {
			this.data = this.get_data();
			this.proceed_rpc();

			return;
		}

		var rpc = this.rpc + '&start_date=' + this.start_date + '&currency=' + this.currency + (this.options.shorten_pricerange ? '&price_format=short' : '');

		this.remote = new Remote({
			rpc: rpc,
			onSuccess: function onSuccess() {
				self.data = this.get_data();

				self.proceed_rpc();
			},
			onError: this.display_error_message.bind(this)
		});
	},

	proceed_rpc: function proceed_rpc() {
		var id = this._currency_select.getElement(':selected').get('value').toLowerCase();

		this._element.currency = {
			'id': id,
			'symbol': this.data.currency_symbol
		};

		if (this.data.list.length < 1) {
			this.display_error_message();
			return;
		}

		//to count all sales in data
		// var count = 0;

		// Object.each(this.data.list, function(el){
		// 	Object.each(el, function(e){
		// 			count += e.length;
		// 	});
		// });

		// console.log(count);

		this.set_beds();
		this.set_price_range();
		//this.set_year_range();

		if (this._controllers) this._controllers.addClass('_ready');

		this.create_chart();

		if (this._list.instance) {
			var data = this.data.list[this._element.selected_graph_id] || [];

			this._list.instance.update(data);
		}
	},

	// set_year_range: function(){
	// 	this._year_range = this._year_range || this._element.getElement('#year_slider');

	// 	if(!this._year_range) return;

	// 	this.data.year_select = {
	// 		'keys': [2000,2001,2002,2003,2004,2005,2006,2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015],
	// 		'values': ['2000','2001','2002','2003','2004','2005','2006','2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015']
	// 	}

	// 	var self = this;
	// 	var values = this.data.year_select.values;

	// 	Object.each(values, function(el, i){
	// 		values[i] = Core.get_html_text(el);
	// 	});

	// 	// values[values.length - 1] += '+';

	// 	// var title = (this._element.type == 'onmarket'? 'Listing Prices: ' : 'Closing Prices: ');
	// 	var title = 'Year: ';

	// 	this._year_range.empty();
	// 	this._year_range.getParent().getElements('input').dispose();

	// 	this.year_range = new Rangeslider(this._year_range, {
	// 		title: title,
	// 		config: this.data.year_select,
	// 		min: this.cookies.year_range? this.cookies.year_range[0] : null,
	// 		max: this.cookies.year_range? this.cookies.year_range[1] : null,
	// 		onComplete: function(min, max){
	// 			console.log('test');
	// 			self.get_min_and_max_year();


	// 			//self.create_chart();

	// 			// if(self._list.update){
	// 			// 	self._list.update();
	// 			// }
	// 			// if(self._list.instance){
	// 			// 	self._list.instance.update();
	// 			// }
	// 		}
	// 	});

	// 	this.get_min_and_max_year();
	// 	this.cookies.year_range = [];
	// },

	set_price_range: function set_price_range() {
		this._price_range = this._price_range || this._element.getElement('.w_rangeslider');

		if (!this._price_range) return;

		var self = this;
		var values = this.data.price_select.values;

		Object.each(values, function (el, i) {
			values[i] = Core.get_html_text(el);
		});

		values[values.length - 1] += '+';

		// var title = (this._element.type == 'onmarket'? 'Listing Prices: ' : 'Closing Prices: ');
		var title = 'Price: ';

		if (this.new_currency) {
			this._price_range.empty();
			this._price_range.getParent().getElements('input').dispose();

			this.price_range = new Rangeslider(this._price_range, {
				title: title,
				config: this.data.price_select,
				min: this.cookies.price_range ? this.cookies.price_range[0] : null,
				max: this.cookies.price_range ? this.cookies.price_range[1] : null,
				onComplete: function onComplete(min, max) {
					self.get_min_and_max_price();
					self.create_chart();

					// if(self._list.update){
					// 	self._list.update();
					// }
					if (self._list.instance) {
						self._list.instance.update();
					}
				}
			});

			this.new_currency = false;
		} else {
			var _rs_title = this.price_range._element.getElement('.w_rangeslider_title');

			if (_rs_title) {
				_rs_title.set('html', title);
			}
		}

		this.get_min_and_max_price();
		this.cookies.price_range = [];
	},

	display_error_message: function display_error_message() {
		this._chart.hide();
		this._veil.hide();

		this._msg = this._msg || this._element.getElement('.error');

		this._msg.show();
	},

	set_beds: function set_beds() {
		var self = this;

		this.active_beds = {
			10: false,
			11: false,
			12: false,
			13: false,
			14: false
		};

		if (this.cookies.beds) {
			Object.each(this.cookies.beds, function (el, i) {
				if (el) {
					self._beds_filter.getElement('li.beds_' + i).addClass('_selected');
				} else {
					self._beds_filter.getElement('li.beds_' + i).removeClass('_selected');
				}
			});

			this.cookies.beds = null;
			this.first_load = false;
			this.beds_multiselect.update_monitor();
		} else if (!this.beds_filter_applied && !this.first_load) {
			this._beds_filter.getElements('li').addClass('_selected');
		}

		this.beds_filter_applied = true;

		Object.each(this.data.list, function (el) {
			Object.each(el, function (e, i) {
				self.active_beds[i] = self.active_beds[i] || e && e.length > 0;
			});
		});

		Object.each(this.active_beds, function (el, i) {
			var _bed = self._beds_filter.getElement('li.beds_' + i);
			if (!_bed) return;

			if (el) {
				_bed.addClass('_active');
			} else {
				_bed.removeClass('_active');
			}
		});
	},

	create_chart: function create_chart() {
		var self = this;

		var options = {
			data: this.data,
			currency_id: this._currency_select.getElement(':selected').get('value'),
			style: this._element.hasClass('_light') ? 'light' : 'dark',
			colors: this.options.colors,
			min: this.min_price,
			max: this.max_price,

			onReady: function onReady() {
				self.cookies.region = JSONMOO.decode(Cookie.read('salesDataRegion'), false);
				if (self.cookies.region) {
					this.charts.some(function (el) {
						if (el.chart.id == self.cookies.region) {
							el._lvt.fireEvent('click');
							return true;
						}
					});
				}

				self._veil.hide();
				self.is_loaded = true;
			},

			onSelectRegion: function onSelectRegion(id) {
				self.create_list(id);
			}
		};

		this.display = new SalesData.Display(this._data_display, options);

		if (!this.first_load) {
			this._beds_filter.getElements('li').each(function (_el) {
				if (!_el.hasClass('_selected')) {
					self.filter_bedrooms(_el.getAttribute('data-id'));
				}
			});
		}
	},

	filter_bedrooms: function filter_bedrooms(id) {
		var self = this;

		if (this.display) {
			this.display.charts.each(function (el) {
				el.chart.series.each(function (e) {
					if (self.first_load) {
						if (e.name == id) {
							e.show();
							self.active_beds[id] = true;
						} else {
							e.hide();
							self.active_beds[e.name] = false;
						}
					} else {
						if (e.name != id) return;

						if (e.visible) {
							e.hide();
							self.active_beds[id] = false;
						} else {
							e.show();
							self.active_beds[id] = true;
						}
					}
				});
			});
		}

		this.get_min_and_max_price();

		if (this.display) {
			this.display.charts.each(function (el) {
				el.chart.yAxis[0].setExtremes(self.min_price, self.max_price);
			});

			this.display.set_info();
		}
	},

	get_min_and_max_price: function get_min_and_max_price() {
		var self = this;
		var min = 1; //since we use logarithmic chart, we can't use 0
		var max = 1;

		Object.each(this.data.list, function (el) {
			Object.each(el, function (e) {
				e.each(function (listing) {
					var id = listing.bedroom_id > 14 ? 14 : listing.bedroom_id;

					if (self.active_beds[id] && listing.y <= self.price_range.get_max() && listing.y >= self.price_range.get_min()) {
						min = min == 1 || listing.y < min ? listing.y : min;
						max = max == 1 || listing.y > max ? listing.y : max;
					}
				});
			});
		});

		this.min_price = Math.max(min, this.price_range.get_min());
		this.max_price = Math.min(max, this.price_range.get_max());
	},

	// get_min_and_max_year: function(){
	// 	var self = this;
	// 	var min = 1; //since we use logarithmic chart, we can't use 0
	// 	var max = 1;

	// 	Object.each(this.data.list, function(el){
	// 		Object.each(el, function(e){
	// 			e.each(function(listing){
	// 				var id = (listing.bedroom_id > 14? 14 : listing.bedroom_id);
	// 				var date = new Date(listing.sale_date);
	// 				var year = date.getFullYear();

	// 				if(self.active_beds[id] && year <= self.year_range.get_max() && year >= self.year_range.get_min()){
	// 					min = ((min == 1 || year < min)? year : min);
	// 					max = ((max == 1 || year > max)? year : max);
	// 				}
	// 			});
	// 		});
	// 	});

	// 	this.min_year = Math.max(min, this.year_range.get_min());
	// 	this.max_year = Math.min(max, this.year_range.get_max());
	// },

	read_cookies: function read_cookies() {
		this.cookies = {
			type: Cookie.read('salesDataType'),
			currency: Cookie.read('salesDataCurrency'),
			period: Cookie.read('salesDataPeriod'),
			beds: JSONMOO.decode(Cookie.read('salesDataBeds'), false),
			price_range: JSONMOO.decode(Cookie.read('salesDataPriceRange'), false),
			region: JSONMOO.decode(Cookie.read('salesDataRegion'), false)
		};
	},

	write_cookies: function write_cookies() {
		var self = this;
		var sales_data_type = this._element.type;
		var sales_data_currency = this.currency;
		var sales_data_period = this.start_date;
		var sales_data_beds = {};

		this._element.getElements('.beds_filter li').each(function (_el) {
			sales_data_beds[_el.getAttribute('data-id')] = self.active_beds[_el.getAttribute('data-id')];
		});

		var sales_data_price_range = [];

		this._element.getElements('.price_filter input').each(function (_el) {
			sales_data_price_range.push(_el.get('value'));
		});

		var sales_data_region = this._element.selected_graph_id;

		Cookie.write('salesDataType', sales_data_type);
		Cookie.write('salesDataCurrency', sales_data_currency);
		Cookie.write('salesDataPeriod', sales_data_period);
		Cookie.write('salesDataBeds', JSONMOO.encode(sales_data_beds));
		Cookie.write('salesDataPriceRange', JSONMOO.encode(sales_data_price_range));
		Cookie.write('salesDataRegion', sales_data_region);
		Cookie.write('salesDataBedsClicked', '');
	}
});

SalesData.Display = new Class({
	Implements: [Options, Events],

	options: {
		data: null
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);

		if (!this.options.data) return;

		this.data = this.options.data;

		this.build();
	},

	build: function build() {
		this.stats = new SalesData.Stats(this._element.getElement('.stats'));
		this._chart = this._element.getElement('.chart');
		this._list = this._element.getElement('.list');

		this._widget = this._element.getParent('.w_sales_data');
		this._widget.set_info = this.set_info.bind(this);

		this._chart.empty();
		this._chart.show();

		this.currency_id = this.options.currency_id;

		this.regions = this.data.regions;

		this.create_multigraph();

		this.set_info();

		this.adjust_titles();

		this.fireEvent('ready');
	},

	get_number_of_regions: function get_number_of_regions() {
		var number_of_graphs = 0;

		Object.each(this.data.list, function (el) {
			var data_length = 0;

			Object.each(el, function (e) {
				data_length += e.length;
			});

			if (data_length > 0) {
				number_of_graphs++;
			}
		});

		return number_of_graphs;
	},

	create_multigraph: function create_multigraph() {
		var self = this;
		var pl = this._chart.getStyle('padding-left').toInt() || 0;
		var pr = this._chart.getStyle('padding-right').toInt() || 0;
		var cont_width = this._chart.getSize().x - pl - pr;

		var add_width = 75;
		var deducted_value = 5; // to reduce the width of the subgraph to have spaces.
		var number_of_graphs = this.get_number_of_regions();

		var width = Math.round((cont_width - add_width) / number_of_graphs, 0);

		add_width = cont_width - width * number_of_graphs;

		var ordered_regions = [{
			id: 2,
			name: this.regions[2]
		}, {
			id: 1,
			name: this.regions[1]
		}, {
			id: 11,
			name: this.regions[11]
		}, {
			id: 3,
			name: this.regions[3]
		}, {
			id: 13,
			name: this.regions[13]
		}, {
			id: 4,
			name: this.regions[4]
		}];

		var wide_graph = true;
		this.charts = [];

		ordered_regions.each(function (el) {
			if (!self.data.list[el.id] || Object.keys(self.data.list[el.id]).length < 1) return;

			var cls = '.subgraph' + (wide_graph ? '._first' : '');

			var _subgraph = new Element(cls);
			_subgraph.inject(self._chart);
			_subgraph.setStyle('width', (wide_graph ? width + add_width : width) - deducted_value);

			_subgraph.is_wide = wide_graph;
			_subgraph.region_id = el.id;

			el._graph = _subgraph;

			var margin_left = wide_graph ? add_width : 0;

			new Element('.subgraph_tick').inject(_subgraph).setStyles({ 'margin-left': margin_left });

			var _title = new Element('.subgraph_title', { 'html': el.name + '<span class="tail">&nbsp;</span>' });

			_title.inject(_subgraph).setStyles({ 'margin-left': margin_left });

			self.stats._element.setStyle('margin-left', add_width);

			wide_graph = false;
		});

		var i = 0;

		//yes, yes, looping 2 times .... because of ie8
		ordered_regions.each(function (el) {
			if (!self.data.list[el.id] || Object.keys(self.data.list[el.id]).length < 1) return;

			var chart_options = {
				data: self.data.list[el.id],
				y_axis_labels_width: i == 0 ? add_width : 0,
				backgroundColor: self._element.getStyle('backgroundColor'),
				colors: self.options.colors,
				currency_symbol: self.data.currency_symbol,
				currency_id: self.options.currency_id,
				x: self.data.x,
				y: self.data.y,
				max: self.options.max,
				min: self.options.min,
				stats: self.stats,
				style: self.options.style,
				name: el.name,
				id: el.id
			};

			var chart = new SalesData.Chart(el._graph, chart_options);
			self.charts.push(chart);

			i++;
		});
	},

	adjust_titles: function adjust_titles() {
		var _titles = this._chart.getElements('.subgraph_title');
		var min_height = 0;

		_titles.each(function (_el) {
			var height = _el.getSize().y;

			if (min_height == 0 || height < min_height) {
				min_height = height;
			}
		});

		_titles.each(function (_el) {
			var padding = _el.getStyle('padding-top').toInt() - (_el.getSize().y - min_height) / 2;

			_el.setStyles({
				'padding-bottom': padding,
				'padding-top': padding
			});
		});
	},

	set_info: function set_info(chart) {
		var chart;

		if (!chart && this._widget.selected_graph_id) {
			this.charts.some(function (el) {
				if (el.chart.id == this._widget.selected_graph_id) {
					chart = el;
					return true;
				}
			}.bind(this));
		}

		this.stats.set_info(chart ? [chart] : this.charts);
	}
});

SalesData.Stats = new Class({
	initialize: function initialize(element) {
		if (!element) return;

		this._element = element;
		this._widget = this._element.getParent('.w_sales_data');
	},

	set_info: function set_info(charts) {
		var sales = 0;
		var median_sales_count = 0;
		var ppsqft = 0;
		var med_price;

		var med_prices_array = [];

		var currency_symbol = this._widget.currency.symbol;
		var currency_id = this._widget.currency.id;

		charts.each(function (el) {
			el.chart.series.each(function (e) {
				if (!e.visible) return;

				e.data.each(function (ee, i) {
					// if(ee.config[4]){
					// 	median_sales_count++;
					// 	ppsqft += (ee.config[4] || 0).toFloat();
					// }

					var config4 = ee.series.options.data[ee.index][4];

					if (config4) {
						median_sales_count++;
						ppsqft += (config4 || 0).toFloat();
					}

					sales++;
					med_prices_array.push(ee.y);
				});
			});
		});

		var info;

		if (sales == 0) {
			info = '<div class="err">There are no recent sales that match the criteria</div>';
		} else {
			med_prices_array = med_prices_array.sort(function (a, b) {
				return a - b;
			});

			if (med_prices_array.length % 2 == 0) {
				med_price = ((med_prices_array[med_prices_array.length / 2] + med_prices_array[med_prices_array.length / 2 - 1]) / 2).round(0);
			} else {
				med_price = med_prices_array[(med_prices_array.length / 2).floor()].round(0);
			}

			if (currency_id == 'xau' || currency_id == 'rub') {
				ppsqft = ppsqft == 0 ? 'N/A' : Core.add_commas((ppsqft / median_sales_count).round(currency_id == 'xau' ? 2 : 0)) + ' <span class="cs">' + currency_symbol + '</span>';
				med_price = Core.add_commas(med_price) + ' <span class="cs">' + currency_symbol + '</span>';
			} else {
				ppsqft = ppsqft == 0 ? 'N/A' : '<span class="cs">' + currency_symbol + '</span>' + Core.add_commas((ppsqft / median_sales_count).round(ppsqft / median_sales_count > 100 ? 0 : 2));
				med_price = '<span class="cs">' + currency_symbol + '</span>' + Core.add_commas(med_price);
			}

			info = '<ul class="clearfix ' + (Core.get_html_text(currency_symbol).length > 1 ? '_letters' : '') + '">' + '<li class="_first"><span class="big">' + sales + '</span>' + (this._widget.type == 'onmarket' ? '<span>Total Listings</span>' : '<span>Total Sales</span>') + '</li>' + '<li><span class="big">' + ppsqft + '</span><span>Median Price / Ft<sup>2</sup></span></li>' + '<li><span class="big">' + med_price + '</span><span>Median Price</span></li>' + '</ul>';
		}

		this._element.set('html', info);
		this.adjust_text_size();
	},

	adjust_text_size: function adjust_text_size() {
		//prices in some currencies are too long, so we have to change size of the text to fit it

		var _big_texts = this._element.getElements('.big');

		if (_big_texts.length == 0) return;

		if (_big_texts[2].get('text').length >= 14) {
			_big_texts.each(function (_el) {
				_el.addClass('_smaller');
			});
		} else {
			_big_texts.each(function (_el) {
				_el.removeClass('_smaller');
			});
		}
	}
});

SalesData.Chart = new Class({
	Implements: [Options, Events],

	options: {
		data: null
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);

		if (!this.options.data) return;

		this.data = this.options.data;

		this.build();
	},

	build: function build() {
		this._widget = this._element.getParent('.w_sales_data');

		this.create_chart();
		this.add_mouse_events();
		this.create_list_view_toggle();
	},

	create_chart: function create_chart() {
		var self = this;
		var series = this.create_series();

		var _chart_cont = this._chart_cont = new Element('.chart_cont').inject(this._element, 'top');

		var max = this.options.max;
		var min = this.options.min > 0 ? this.options.min : 1;

		this.chart = new Highcharts.Chart({
			chart: {
				renderTo: _chart_cont,
				type: 'scatter',
				plotBackgroundColor: this.options.backgroundColor,
				backgroundColor: this.options.backgroundColor,
				marginBottom: 0,
				marginLeft: this.options.y_axis_labels_width,
				marginRight: 0,
				animation: false,
				spacingTop: 20,
				events: {
					tooltipHide: function tooltipHide() {
						if (self._tooltip) {
							self._tooltip.hide();
						}
					},
					tooltipMove: function tooltipMove(e) {
						self.position_tooltip(self._element, e[0], e[1]);
					},
					click: function click() {
						if (!Core.is_touch_supported()) {
							self._lvt.fireEvent('click');
						}
					}
				}
			},

			xAxis: {
				categories: self.regions_by_name,

				labels: {
					enabled: false
				},

				min: 0.5,
				max: 5.5,

				minPadding: 0.2,
				maxPadding: 0.2,

				title: {
					text: null
				},

				tickLength: 0
			},

			yAxis: {
				type: 'logarithmic',
				min: min,
				max: max,
				gridLineColor: '#aaa',
				gridLineDashStyle: 'dash',
				showFirstLabel: false,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: this._element.is_wide ? this.options.y.label : null,
					style: {
						color: '#999'
					},
					margin: 10
				},

				labels: {
					enabled: this._element.is_wide,
					style: {
						color: '#999'
					},
					formatter: function formatter() {
						var cs = Core.get_html_text(self.options.currency_symbol || '&#36;');
						if (cs.length > 1) cs = '';

						if (this.value < 100) {
							return cs + Highcharts.numberFormat(this.value, 2);
						} else {
							var s;

							if (this.value % 1000000000 == 0) {
								s = this.value / 1000000000 + 'G';
							} else if (this.value % 1000000 == 0) {
								s = this.value / 1000000 + 'M';
							} else if (this.value % 1000 == 0) {
								s = this.value / 1000 + 'k';
							} else {
								s = this.value;
							}

							return cs + s;
						}
					}
				}
			},

			series: series,

			tooltip: {
				useHTML: true,
				formatter: function formatter() {
					if (!this.point.series.visible) return;

					var index;
					if (this.point.dataGroup) {
						index = this.point.dataGroup.start;
					} else {
						index = this.point.index;
					}

					var content = this.point.series.options.data[index][2];

					self.display_tooltip(content, this.point.series.color);
					self.position_tooltip(self._element, this.point.plotX, this.point.plotY);

					return false;
				}
			},

			plotOptions: {
				column: {
					stacking: 'normal'
				},

				scatter: {
					marker: {
						radius: 7
					},
					events: {
						click: function click(e) {
							var stop = false;
							var index;

							// to display the tooltip on the first click
							if (Core.is_touch_supported()) {
								if (self.active_series != e.point) {
									stop = true;
								}

								self.active_series = e.point;

								if (stop) return;
							}

							if (e.point.dataGroup) {
								index = e.point.dataGroup.start;
							} else {
								index = e.point.index;
							}

							var url = e.point.series.options.data[index][3];

							if (url) {
								Cookie.write('salesDataSeriesClicked', true);

								window.location = url;
							}

							//NCR-5306 if user click the dot while on the market insight landing page.
							if ($(document.body).get('id') === 'min') {
								document.fireEvent('miSaveActiveGraph', ['salesData']);
							}

							self.seriesClicked = true;
						},
						mouseOut: function mouseOut() {
							if (self._tooltip) {
								self._tooltip.hide();
							}
						}
					}
				},

				series: {
					cursor: 'pointer'
				}
			},

			credits: {
				enabled: false
			},

			title: {
				text: null
			},

			legend: {
				enabled: false
			}
		});

		this.chart.id = this.options.id;
	},

	// get_prices_intervals: function(){ //for better distribution of dots
	// 	var prices = {};

	// 	var max = this.options.max;
	// 	var min = (this.options.min > 0? this.options.min : 1);

	// 	var range = max - min;
	// 	var step = range / 20;

	// 	while(range > 0){
	// 		prices[range] = [];
	// 		range -= step;
	// 	}

	// 	return prices;
	// },

	get_x: function get_x(number) {
		var x = number % 5 + 1;

		//todo: we need better distribution of dots on x axis

		return x;
	},

	create_series: function create_series() {
		var self = this;
		var series = [];
		// var prices = this.get_prices_intervals(); //for better distribution of dots

		Object.each(this.data, function (el, beds_id) {
			var graph_data = [];
			var url = [];

			el.each(function (e, i) {
				if (e.y > self.options.max || e.y < self.options.min) return;

				var x = self.get_x(beds_id.toInt() + i + (e.sqft || 0));

				graph_data.push([x, e.y, e.tooltip, e.url_sold || e.url, e.ppsqft]);

				url.push(e.url_sold);
			});

			series.push({
				data: graph_data,
				color: self.options.colors[beds_id],
				marker: { symbol: 'circle' },
				name: beds_id
			});
		});

		return series;
	},

	add_mouse_events: function add_mouse_events() {
		//if(Core.is_touch_supported()) return;

		var self = this;
		var _rect = this._element.getElements('svg>rect');
		var color = this.options.style == 'light' ? '#ccc' : '#777';
		var stats = self.options.stats;

		if (_rect) {
			_rect = _rect[1] || _rect[0];
		}

		this._element.addEvents({
			'touchstart': function touchstart() {
				var _tooltips = document.getElements('.chart_tooltip._sales_data');
				if (_tooltips) {
					_tooltips.each(function (_el) {
						_el.hide();
					});
				}
			},

			'mouseenter': function mouseenter() {
				if (Core.is_touch_supported()) {
					var _current_active_subgraph = document.getElement('.subgraph._hover');
					if (_current_active_subgraph) {
						_current_active_subgraph.fireEvent('mouseleave');
					}
				}

				self._element.addClass('_hover');

				if (_rect) {
					_rect.setProperty('fill', color);
					_rect.setProperty('height', _rect.getProperty('height').toInt() + 20);
					_rect.setProperty('y', 0);
				}

				stats.gen_info = stats._element.get('html');
				stats.set_info([self]);
			},

			'mouseleave': function mouseleave() {
				self._element.removeClass('_hover');

				if (_rect) {
					_rect.setProperty('fill', self.options.backgroundColor);
					_rect.setProperty('height', _rect.getProperty('height').toInt() - 20);
				}

				if (self.hidden) {
					self.hidden = false;
					return;
				}

				stats._element.set('html', stats.gen_info);
			},

			'click': function click(e) {
				self.hidden = true;

				if (e.target != self._lvt) {
					self._lvt.fireEvent('click');
				}
			}
		});
	},

	display_tooltip: function display_tooltip(tooltip, color) {
		this._tooltip = this._tooltip || new Element('.chart_tooltip._sales_data', {
			'html': '<div class="info"></div><div class="pointer">&nbsp;</div>'
		}).inject(document.body);

		tooltip += '<br/><br/>Click dot for full ' + (this._widget.type == 'onmarket' ? 'listing details' : 'sales summary');

		this._tooltip.getElement('.info').set('html', tooltip);
		this._tooltip.setStyle('borderColor', color);
		this._tooltip.getElement('.pointer').setStyle('borderTopColor', color);
		this._tooltip.show();
	},

	position_tooltip: function position_tooltip(_cont, x, y) {
		// To center the tooltip, we need to use the position of the subgraph_title because this has the same width of the graph.
		var pos_x = _cont.getElement('.subgraph_title').getPosition().x + x - this._tooltip.getSize().x / 2;
		var pos_y = _cont.getPosition().y + y - this._tooltip.getSize().y / 2 - 35; // - this._tooltip.getElement('.pointer').getSize().y - 10;

		this._tooltip.setStyles({
			'top': pos_y,
			'left': pos_x
		});
	},

	create_list_view_toggle: function create_list_view_toggle() {
		var self = this;
		var _list_view_toggle = this._lvt = new Element('.list_view_toggle', { 'html': 'Go to List View' });

		_list_view_toggle.inject(this._element, 'top');
		_list_view_toggle.setStyles({
			'margin-left': this.options.y_axis_labels_width
		});

		_list_view_toggle.addEvents({
			'click': function click() {
				if (self.seriesClicked) {
					return;
				}

				self._widget.selected_graph_id = self.chart.id;

				self.options.stats.gen_info = self.options.stats._element.get('html');
				self.options.stats.set_info([self]);
				self.show_list();
			}
		});
	},

	show_list: function show_list() {
		if (this.list) {
			this.list.show();
		} else {
			this.list = this.list || new SalesData.List(this._element.getParent().getNext('.list'), this.options);
		}
	}
});

SalesData.List = new Class({
	Implements: [Options, Events],

	options: {
		data: null
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);

		if (!this.options.data) return;

		this.data = this.options.data;

		this.build();
	},

	build: function build() {
		this._widget = this._element.getParent('.w_sales_data');
		this._chart = this._element.getPrevious('.chart');
		this.show();
	},

	set_content: function set_content() {
		var content = '<span class="region_name">' + this.options.name + '</span>';

		this._element.set('html', content);
		this.create_table();
		this.add_back_link();
	},

	create_table: function create_table() {
		var _table = this._element.getElement('.w_divtable');

		if (_table) {
			_table.dispose();
		}

		this._table = new Element('.w_divtable' + (this._widget.type == 'onmarket' ? '._onmarket' : ''));

		this._thead = new Element('.thead', {
			'html': '<div class="tr">' + '<div class="th building_name"><div class="th_content">Building / Address</div></div>' + '<div class="th size"><div class="th_content">Size</div></div>' + '<div class="th closing_price"><div class="th_content">' + (this._widget.type == 'onmarket' ? 'Price' : 'Closing Price') + '</div></div>' + '<div class="th closing_date"><div class="th_content">' + (this._widget.type == 'onmarket' ? '' : 'Closing Date') + '</div></div>' + '</div>'
		});

		this._tbody = new Element('.tbody');

		this._table.adopt([this._thead, this._tbody]);

		this._element.adopt(this._table);

		this.add_rows();
	},

	add_rows: function add_rows() {
		var self = this;
		var opts = this.options;

		this.sorted_data = this.sorted_data || (this._widget.type == 'sold' ? this.sort_by_date() : this.sort_by_price());

		var selected_bedrooms = [];

		var cookie_beds = Cookie.read('salesDataBeds');

		if (Cookie.read('salesDataBedsClicked')) {
			this._widget.getElements('.beds_filter ._active._selected').each(function (_el) {
				selected_bedrooms.push(_el.getAttribute('data-id').toInt());
			});
		} else if (cookie_beds) {
			cookie_beds = JSONMOO.decode(cookie_beds, false);

			Object.each(cookie_beds, function (el, i) {
				if (el == true) {
					selected_bedrooms.push(i.toInt());
				}
			});
		} else {
			this._widget.getElements('.beds_filter li').each(function (_el) {
				selected_bedrooms.push(_el.getAttribute('data-id').toInt());
			});
		}

		var extremes = this._widget.getElements('.price_filter input[type="hidden"]');

		var min = extremes[0] ? extremes[0].get('value') : opts.min;
		var max = extremes[1] ? extremes[1].get('value') : opts.max;

		this.sorted_data.each(function (el) {
			var id = el.bedroom_id.toInt() > 14 ? 14 : el.bedroom_id.toInt();

			if (el.y < min || el.y > max || !selected_bedrooms.contains(id)) return;

			var _tr = new Element('.tr');

			_tr.addEvents({
				'click': function click() {
					window.location = el.url_sold || el.url;

					//NCR-5306 if user click the dot while on the market insight landing page.
					if ($(document.body).get('id') === 'min') {
						document.fireEvent('miSaveActiveGraph', ['salesData']);
					}
				}
			});

			_tr.setStyle('border-left', '6px solid ' + opts.colors[id]);

			var name = (el.name || el.street_address).trim();

			var building = (name && name != '' ? '<span>' + (el.name || el.street_address) + ', </span>' : '') + '<span class="unit"> Apt ' + el.unit + '</span>' + (el.name ? '<br/>' + el.street_address : '');

			var size = '<span>' + (Number.from(el.bedroom) ? Number.from(el.bedroom) : el.bedroom) + (Number.from(el.bedroom) ? Number.from(el.bedroom) > 1 ? ' beds' : ' bed' : '') + '</span><br/>' + Number.from(el.bathroom) + (Number.from(el.bathroom) > 1 ? ' baths' : ' bath') + (el.sqft == 0 ? '' : ' | ' + el.sqft_format + ' / ft <sup>2</sup>');

			var closing_price = '<span>' + el.sale_price_format + '</span>' + (el.ppsqft == 0 ? '' : '<br/> Approx. ' + el.ppsqft_format + ' / ft <sup>2</sup>');
			var closing_date = '<span>' + (el.sale_date ? el.sale_date : '') + '</span>';

			new Element('.td.building_name', { 'html': '<div class="td_content">' + building + '</div>' }).inject(_tr);
			new Element('.td.size', { 'html': '<div class="td_content">' + size + '</div>' }).inject(_tr);
			new Element('.td.closing_price', { 'html': '<div class="td_content">' + closing_price + '</div>' }).inject(_tr);
			new Element('.td.closing_date', { 'html': '<div class="td_content">' + closing_date + '</div>' }).inject(_tr);

			_tr.inject(self._tbody);
		});

		new Divtable(this._table, {
			'zebra_order': 'odd'
		});

		// console.log(this._element.getSize().y, this._chart.getSize().y);

		if (this._element.getSize().y > this._chart.getSize().y) {
			this._thead.addClass('_table_scroll');

			new StyledScroll(this._tbody, {
				type: 'v',
				max_height: 315
			});
		}
	},

	update: function update(data) {
		if (data) {
			this.data = data;
			this.sorted_data = null;
		}

		this.create_table();
	},

	sort_by_price: function sort_by_price() {
		var sorted_list = [];

		Object.each(this.data, function (el) {
			el.each(function (e) {
				sorted_list.push(e);
			});
		});

		if (sorted_list.length > 1) {
			sorted_list = sorted_list.sort(function (a, b) {
				var price_a = a.sale_price.toInt();
				var price_b = b.sale_price.toInt();

				return price_a > price_b ? -1 : 1;
			});
		}

		return sorted_list;
	},

	sort_by_date: function sort_by_date() {
		var sorted_list = [];

		Object.each(this.data, function (el) {
			el.each(function (e) {
				sorted_list.push(e);
			});
		});

		if (sorted_list.length > 1) {
			sorted_list = sorted_list.sort(function (a, b) {
				var date_a = new Date(a.sale_date).set({ sec: 0, ms: 0 }).format("%s");
				var date_b = new Date(b.sale_date).set({ sec: 0, ms: 0 }).format("%s");

				return date_a > date_b ? -1 : 1;
			});
		}

		return sorted_list;
	},

	add_back_link: function add_back_link() {
		if (this._back_link) {
			this._back_link.inject(this._element, 'top');
			return;
		}

		var self = this;
		this._back_link = new Element('.back', { 'text': 'Back to Graph' });

		this._back_link.inject(this._element, 'top');

		this._back_link.addEvents({
			'click': function click() {
				self._widget.selected_graph_id = null;
				self.hide();
			}
		});
	},

	show: function show() {
		this.set_content();
		this._chart.hide();
		this._widget.addClass('_list_view');

		this._widget.set_info();
		this._element.instance = this;
	},

	hide: function hide() {
		this._widget.removeClass('_list_view');
		this._element.empty();
		this._chart.show();

		this._widget.set_info();
		this._element.instance = null;
		Cookie.write('salesDataRegion', null);
	}
});
"use strict";

var SearchResultsMap = new Class({
	Implements: [Options, Events],

	options: {
		form: null,
		data_rpc: null,
		is_building: false,
		is_agents: false,
		label_on_marker: true,
		show_starting_price: false,
		search_type: null,
		counts_only: false, // show counts of the buildings per hood on firstload
		with_hover_icon: true,
		previous_state: null,
		page_context: null,
		icon_path: null,
		default_hood_id: null,
		is_click_style_hover: false,
		view: null,
		polygon: {
			idle: {
				strokeColor: "#bc3a5b",
				strokeWeight: 2,
				strokeOpacity: 0.4,
				fillColor: "#000000",
				fillOpacity: 0,
				clickable: true
			},
			hover: {
				fillColor: "#bc3a5b",
				fillOpacity: 0.35,
				clickable: true
			},
			active: {
				strokeColor: "#25B3E4",
				strokeWeight: 4,
				strokeOpacity: 0.8,
				fillColor: "#000000",
				fillOpacity: 0,
				clickable: false
			}
		},

		data: null
	},

	initialize: function initialize(map, options) {
		if (!map || !(map instanceof SimpleMap)) return;

		this.setOptions(options);

		this._form = this.options.form;
		this._button = this.options.button;

		this.map = map;

		this.page_id = $$('body')[0].get('id');

		this.state = new State();

		this.build();
	},

	build: function build() {
		var self = this;
		this.isFirstLoading = true;
		this.enabled = true;
		this.search_results_regions = [];
		this.rpc = this.options.data_rpc;

		if (!this.options.data) {
			self.get_data();
		} else {
			self.process_data();
		}
	},

	get_data: function get_data() {
		var self = this;
		var rpc = this.rpc;
		if (this.options.counts_only && this.options.is_building) {
			rpc += (rpc.indexOf('?') == -1 ? '?' : '&') + 'buildings=false';
		}

		if (this.options.filter_param) {
			rpc += (rpc.indexOf('?') == -1 ? '?' : '&') + this.options.filter_param;
		}

		new Remote({
			rpc: this._form != null ? this._form.getAttribute('data-rpc') + '?listings=1' : rpc,
			data: this._form != null ? '&' + this._form.toQueryString().trim() + '&ajax=1' : '',
			onSuccess: function onSuccess() {
				self.options.data = this.get_data();
				self.process_data();
			}
		});
	},

	refresh_data: function refresh_data(data, previous_region_id) {
		this.options.data = data;
		this.isFirstLoading = false;
		//don't show prev state after change criterias
		this.options.previous_state = null;
		if (this.map.current_marker) {
			this.has_opened_bubble = false;
			this.map.current_marker.marker.bubble.close();
		}
		this.process_data(previous_region_id);
	},

	process_data: function process_data(previous_region_id, changed_by_filter) {
		var self = this;
		var data = this.options.data;
		if (!data) return;

		this.map.clear_markers();
		this.fireEvent('dataLoad', data);

		this.icon_path = Res_i + '/w/simplemap/markers/';

		this.clear_regions();

		var region;
		var number_of_regions = this.number_of_regions = Object.getLength(data.listings || data.data);
		var previous_region;
		var avail_regions = [];
		var prev_state_region_id = this.options.previous_state ? this.options.previous_state.hood_id : null;
		var default_region;

		Object.each(data.listings || data.data, function (el, i) {

			var total = el.total || 0;
			var coords = el.coordinates || [];
			var has_marker;

			avail_regions.push(+i);
			//don't show marker for opened region or for restored region from previous state
			if (previous_region_id) {
				has_marker = i != previous_region_id;
			} else if (prev_state_region_id) {
				has_marker = i != prev_state_region_id;
			} else {
				has_marker = number_of_regions > 1;
			}

			region = this.set_nh(i, total, el.name, coords, has_marker);

			if (region) {
				region.url = el.url || '';
				region.name = el.name || 'Unknown';
				region.data = el.data;

				if (previous_region_id && changed_by_filter && region.region_id === previous_region_id && (data.listings || data.data)[region.region_id].data) {
					region.gross_data = (data.listings || data.data)[region.region_id].data;
				} else if (this.options.is_building && this.options.counts_only == false) {
					region.gross_data = data.data[region.region_id].data;
				} else if (!this.options.is_building && number_of_regions == 1 && data.listings[region.region_id].data) {
					region.gross_data = data.listings[region.region_id].data;
				}

				// if the region in the previous one
				if (region.region_id === prev_state_region_id || changed_by_filter && region.region_id === previous_region_id && region.gross_data) {
					previous_region = region;
				}

				if (parseInt(region.region_id, 10) === this.options.default_hood_id) {
					default_region = region;
				}
			}
		}.bind(this));

		//if thereis no data for opened region.
		if (this.current_region && avail_regions.indexOf(+this.current_region.region_id) == -1) {
			this.current_region = null;
		}

		if (number_of_regions == 1) {
			this.handle_region_click(region, this.options.previous_state);
		} else if (number_of_regions > 1) {
			if (this.isFirstLoading) {
				this.map.fit_markers();
			}
			// restore previous hood
			if (previous_region) {
				this.handle_region_click(previous_region, this.options.previous_state);
			} else if (default_region) {
				// select the default region
				this.handle_region_click(default_region);
			}
		}

		// process buildings
		if (data.buildings) {
			Object.each(data.buildings, function (el, i) {

				var building = el;
				var markerLabel = "\n\t\t\t\t\t<span class=\"arrow\"></span>\n\t\t\t\t\t<span class=\"tooltip\">\n\t\t\t\t\t\t<span class=\"tooltip-1\">" + Number(building.total).toLocaleString() + (Number(building.total) === 1 ? " Agent" : " Agents") + " in</span>\n\t\t\t\t\t\t<span class=\"tooltip-2\">" + building.name + "</span>\n\t\t\t\t\t</span>\n\t\t\t\t";
				var icon = this.icon_path + 'blg-1.png';
				var iconHover = this.icon_path + 'blg-hover-1.png';

				// var sm_marker = building.sm_marker = this.map.add_marker({
				var sm_marker = this.map.add_marker({
					lat: building.lat,
					lng: building.lng,
					icon: icon,
					// hover_icon: iconHover,
					base_point: 'center',
					// temporarily removed names from neighborhood markers
					label: {
						content: this.options.label_on_marker ? markerLabel : null,
						add_class: '_building'
					},
					scalable: true,
					callbacks: {
						onClick: function onClick() {
							self.handle_building_click(sm_marker, building);
						},

						onStopMouseover: function onStopMouseover() {
							self.handle_building_mouseover(sm_marker);
						},

						onMouseout: function onMouseout() {
							self.handle_building_mouseout(sm_marker);
						}

					}
				});

				var marker = sm_marker.marker;
			}.bind(this));
		}
	},
	clear_regions: function clear_regions() {
		if (this.search_results_regions) {
			this.search_results_regions.each(function (region) {
				region.setMap(null);
				if (region.sm_marker) {
					region.sm_marker.remove_from_map();
				}
			});
		}
		this.search_results_regions = [];
	},
	handle_region_click: function handle_region_click(region, previousState, changed_by_filter) {

		// if(!this.enabled || !region || region.is_active || !this.map.map.bubble_options.visible) return;
		if (!this.enabled || !region || !this.map.map.bubble_options.visible) return;

		var self = this;

		this.region_clicked = true;
		region.is_active = true;

		if (this.options.is_click_style_hover) {
			region.setOptions(this.options.polygon.hover);
		} else {
			region.setOptions(this.options.polygon.active);
		}

		this.fireEvent('request', region);

		if (!region.gross_data) {
			if (region.remote) {
				region.remote.cancel();
			}

			var rpc = this.rpc;
			rpc += rpc.indexOf('?') == -1 ? '?' : '&';

			if (self.options.counts_only && this.options.is_building) {
				rpc += 'hoodId=' + region.region_id;
			} else {
				rpc += 'hood=' + region.region_id;
			}

			if (this.options.filter_param) {
				rpc += '&' + this.options.filter_param;
			}

			region.remote = new Remote({
				rpc: self._form != null ? self._form.getAttribute('data-rpc') + '?listings=1&hoods[]=' + region.region_id : rpc,
				data: self._form != null ? '&' + self._form.toQueryString().trim() + '&ajax=1' : '',
				onSuccess: function onSuccess() {
					if ((this.get_data().listings || this.get_data().data)[region.region_id]) {
						region.gross_data = (this.get_data().listings || this.get_data().data)[region.region_id].data;

						// if filter has changed update the buildings of the current hood and the counts of the other hoods
						if (changed_by_filter) {
							self.options.data = this.get_data();
							self.process_data(region.region_id, changed_by_filter);
						} else {
							self.show_buildings(region, previousState);
						}
					} else if (changed_by_filter) {
						// if the current region doesnt have data pass, we still need to update the count of the other hoods
						self.options.data = this.get_data();
						self.process_data();
					}

					self.fireEvent('dataLoad', region);
				}
			});
		} else {
			this.show_buildings(region, previousState);
			this.fireEvent('dataLoad', region);
		}

		if (this.current_region && this.current_region.region_id !== region.region_id) {
			this.deactive_current_region();
		}

		if (this.current_building) {
			this.deactive_current_building();
			this.current_building = null;
		}

		if (this.current_big_bubble) {
			this.current_big_bubble.close();
		}

		if (this.isFirstLoading) {
			this.fit_region(region);
		}

		if (this.options.is_click_style_hover) {
			region.setOptions(this.options.polygon.hover);
		} else {
			region.setOptions(this.options.polygon.active);
		}

		this.current_region = region;

		_gaq.push(['_trackEvent', 'map', 'loaded', 'view_region']);
	},

	deactive_current_region: function deactive_current_region() {
		this.current_region.in_region = false;
		this.current_region.is_active = false;

		if (this.current_region.building_markers) {
			this.current_region.building_markers.each(function (el) {
				el.remove_from_map();
			});
		}
		if (this.current_region.marker) {
			this.current_region.marker.setMap(this.map.map);

			if (this.current_region.marker.label) {
				this.current_region.marker.label.open();
			}
		} else {
			this.set_marker(this.current_region);
		}
		this.handle_region_mouseout(this.current_region);
	},

	deactive_current_building: function deactive_current_building() {
		if (this.current_building) {
			this.current_building.marker.icon.url = this.icon_path + 'blg-1.png';
			this.current_building.change_icon_image(this.icon_path + 'blg-1.png');
			$(this.current_building.marker.label._bubble_content).removeClass('hover');
		}
	},

	set_marker: function set_marker(region) {
		var self = this;
		var markerLabel;
		var icon;

		// marker special for agents map
		if (this.options.is_agents) {
			markerLabel = "\n\t\t\t\t<span class=\"number\">" + Number(region.total).toLocaleString() + "</span>\n\t\t\t\t<span class=\"text\">" + (Number(region.total) === 1 ? "Agent" : "Agents") + "</span>\n\t\t\t";
			// icon =  this.icon_path + 'blg-1.png';
			icon = self.icon_path + 'region-marker.png';
		} else {
			// default markers
			markerLabel = '<span class="number">' + Number(region.total).toLocaleString() + '</span>';
			icon = self.icon_path + 'region-marker.png';
		}

		var sm_marker = region.sm_marker = this.map.add_marker({
			lat: region.center_lat,
			lng: region.center_lng,
			icon: icon,
			base_point: 'center',
			// temporarily removed names from neighborhood markers
			label: {
				content: self.options.label_on_marker ? markerLabel : null,
				add_class: '_hood'
			},
			scalable: true
		});

		var marker = region.marker = sm_marker.marker;

		this.add_events(marker, region);
	},

	set_nh: function set_nh(id, total, name, coordinates, has_marker) {
		if (!coordinates || typeOf(coordinates) != 'array' || coordinates.length < 3) return null;

		var coords = [],
		    most_top_lat,
		    most_bottom_lat,
		    most_left_lng,
		    most_right_lng,
		    center_lat,
		    center_lng,
		    center_latlng;

		var opts = this.options.polygon;

		coordinates.each(function (el) {
			if (el[0] && el[1]) {
				var latlng = new google.maps.LatLng(el[1], el[0]);
				coords.push(latlng);

				if (!most_top_lat || el[1] > most_top_lat) {
					most_top_lat = el[1];
				}

				if (!most_bottom_lat || el[1] < most_bottom_lat) {
					most_bottom_lat = el[1];
				}

				if (!most_left_lng || el[0] < most_left_lng) {
					most_left_lng = el[0];
				}

				if (!most_right_lng || el[0] > most_right_lng) {
					most_right_lng = el[0];
				}
			}
		});

		center_lat = (most_top_lat + most_bottom_lat) / 2;
		center_lng = (most_left_lng + most_right_lng) / 2;

		if (coords.length < 3) return null;

		var map = this.map.map;

		var region = new google.maps.Polygon({
			paths: coords
		});
		//keep coords to create marker later
		region.center_lat = center_lat;
		region.center_lng = center_lng;
		region.total = total;

		region.region_id = id;

		region.setOptions(opts.idle);

		this.search_results_regions.push(region);

		region.setMap(map);

		region.coordinates = coordinates;

		name = name.replace('/ ', '/');
		name = name.replace(' /', '/');
		name = name.replace(' / ', '/');
		name = name.replace('/', ' /<br/>');

		this.add_events(region, region);

		if (has_marker) {
			this.set_marker(region);
		}

		return region;
	},

	add_events: function add_events(marker, region) {
		var self = this;
		google.maps.event.addListener(marker, 'click', function () {
			self.handle_region_click(region);
		});

		google.maps.event.addListener(marker, 'mouseover', function () {
			self.handle_region_mouseover(region);
		});

		google.maps.event.addListener(marker, 'mousemove', function () {
			self.handle_region_mousemove(region);
		});

		google.maps.event.addListener(marker, 'mouseout', function () {
			self.handle_region_mouseout(region);
		});
	},

	handle_region_mouseover: function handle_region_mouseover(region) {
		if (!this.enabled || !region) return;

		if (region.is_active || region.in_region) return;

		//(function(){
		region.setOptions(this.options.polygon.hover);
		//}.bind(this)).delay(20);

		region.in_region = true;
	},

	handle_region_mousemove: function handle_region_mousemove(region) {
		if (!this.enabled || !region) return;

		if (this.map.map.bubble_options.visible) {
			this.handle_region_mouseover(region);
		} else {
			this.handle_region_mouseout(region);
		}
	},

	handle_region_mouseout: function handle_region_mouseout(region) {
		if (!this.enabled || !region || region.is_active) return;

		(function () {
			if (!region.in_region) {
				region.setOptions(this.options.polygon.idle);
			}
		}).bind(this).delay(20);

		region.in_region = false;
	},

	handle_building_click: function handle_building_click(smmarker, building) {

		this.deactive_current_region();

		this.deactive_current_building();

		this.current_building = smmarker;

		smmarker.change_icon_image(this.icon_path + 'blg-hover-1.png');
		$(smmarker.marker.label._bubble_content).addClass('hover');

		this.fireEvent('request', building);
	},

	handle_building_mouseover: function handle_building_mouseover(smmarker) {
		smmarker.change_icon_image(this.icon_path + 'blg-hover-1.png');
		$(smmarker.marker.label._bubble_content).addClass('hover');
	},

	handle_building_mouseout: function handle_building_mouseout(smmarker) {
		if (this.current_building === smmarker) return;

		smmarker.change_icon_image(this.icon_path + 'blg-1.png');
		$(smmarker.marker.label._bubble_content).removeClass('hover');
	},

	fit_region: function fit_region(region) {
		if (!region) return;
		var bounds = new google.maps.LatLngBounds();
		var points = [];

		region.coordinates.each(function (el) {
			var point = new google.maps.LatLng(el[1], el[0]);
			bounds.extend(point);
			points.push(point);
		});

		this.map.map.fitBounds(bounds);
	},

	show_buildings: function show_buildings(region, previousState) {

		var data = region.gross_data;

		if (!data || data.length == 0) return;

		var self = this;

		if (region.sm_marker) {
			region.sm_marker.remove_from_map();
		}

		if (region.building_markers) {
			region.building_markers.each(function (el) {
				el.marker.setMap(self.map.map);
				if (el.marker.label) {
					el.marker.label.open();
				}
			});

			return;
		}

		region.building_markers = [];

		Object.each(data, function (el, i) {
			if (!self.in_new_york(el.lat, el.lng)) return;

			var total = (el.total && el.total > 1 ? el.total : '') + '';

			var marker;
			var currentBuildingId = 'building-' + i;

			// set if you want to open the tooltip for this marker
			var initOpen = previousState && previousState.building_id === currentBuildingId ? true : false;

			var sm_marker = self.map.add_marker({
				id: currentBuildingId,
				init_open: initOpen,
				lat: el.lat,
				lng: el.lng,
				label: {
					content: self.options.label_on_marker ? '<span class="">' + total + '</span>' : '<span class="">' + total + '</span>', //
					add_class: '_building _' + i + (total.length > 0 ? ' _with_count _size_' + (total.length > 4 ? 4 : total.length) : '') + (el.offer_tag_id ? ' _offer_' + el.offer_tag_id : '')
				},
				icon: (self.options.icon_path || self.icon_path) + (total.length > 4 ? 4 : total.length) + '.png',
				hover_icon: self.options.with_hover_icon ? self.icon_path + (total.length > 4 ? 4 : total.length) + '-hover-red.png' : null,
				bubble: {
					content: self.get_bubble_content(el),
					add_class: self.options.is_building ? '_building' : '_big',
					offset: {
						x: 16,
						y: -45
					},
					side: 'right'
				},
				base_point: 'center',
				center_on_click: self.options.is_building ? true : false,
				current_bubble_open_on_mouseover: self.options.is_building ? true : false,
				onBubbleReady: function onBubbleReady(_el) {
					if (el.bubble_is_ready) return;

					var _ul = _el.getElement('ul');

					_el.addEvents({
						'mouseenter': function mouseenter() {
							self.in_bubble = true;
						},

						'mouseleave': function mouseleave() {
							self.in_bubble = false;

							// if(self.options.is_building){
							//	 _el.getElement('.w_googlemaps_infobox_content').set('html', self._prev_content);
							// }
						}
					});

					if (_ul && _ul.getSize().y > _el.getSize().y) {
						_ul.setStyles({
							'overflow-y': 'scroll',
							'max-height': 210
						});
					}

					var _lis = _el.getElements('li');

					_lis.each(function (_e) {
						if (_e.getAttribute('data-rpc')) {
							var tmpRpc = _e.getAttribute('data-rpc');
							if (tmpRpc.indexOf('/rpc/listing-popup') != -1) {
								_e.setAttribute('data-rpc', tmpRpc.replace('/rpc/listing-popup', '/rpc/listing-popup-v2'));
							}
							var display = 'map';
							if (_e.getAttribute('data-images-cnt') && parseInt(_e.getAttribute('data-images-cnt'), 10) > 0) {
								display = 'gallery';
							}
							_e.blimp = new BlimpExtV2(_e, {
								cache: true,
								draggable: true,
								show_veil: true,
								display: display,
								withThumbnails: true,
								fullscreen: true,

								onFetch: function onFetch() {
									// Save state : send event to mapmultipleview, because we need the criteria etc
									self.fireEvent('saveState', { building_id: currentBuildingId });

									sm_marker.marker.clicked = true;
									self.region_clicked = false;
									self.fireEvent('request');

									_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
								},

								onPostRpc: function onPostRpc() {
									this.add_extra(true);

									self.fireEvent('dataLoad');

									Core.compile_html(this._element);
								},

								onHide: function onHide() {
									// delete state
									self.state.remove(self.page_id);

									if (this.email_blimp) {
										this.email_blimp.hide();
									}

									if (this.save_blimp) {
										this.save_blimp.hide();
									}
								}
							});
						} else if (_e.getAttribute('data-url')) {
							_e.addEvent('click', function () {
								window.location = _e.getAttribute('data-url');
							});
						}
					});

					if (_ul) {
						_ul.addEvent('click:relay("li a")', function (e, i) {
							if (e && e.stop) e.stop();

							self.fireEvent('request', [e, i]);
						});
					}

					el.bubble_is_ready = true;
				},

				callbacks: {
					onClick: function onClick() {
						// open the buble when the user click the other marker and close the current open bubble.
						if (self.map.current_marker && self.map.current_marker != sm_marker) {
							self.has_opened_bubble = false;

							if (self.options.is_building) {
								if (self.map.current_marker) {
									self.map.current_marker.marker.bubble.close();
								}
							}

							if (self.map.current_marker.marker.label && self.map.current_marker.marker.label._bubble_content) {
								self.map.current_marker.marker.label._bubble_content.removeClass('_active');
							}

							google.maps.event.trigger(sm_marker.marker, "mouseover");
						}

						self.has_opened_bubble = true;

						self.map.current_marker = sm_marker;

						self.current_big_bubble = sm_marker.marker.bubble;

						// add active class to the label of the current marker
						if (self.map.current_marker.marker.label && self.map.current_marker.marker.label._bubble_content) {
							self.map.current_marker.marker.label._bubble_content.addClass('_active');
						}

						if (!self.options.is_building) return;

						(function () {
							var _bubble = sm_marker.marker.bubble.infobox._div;

							if (!_bubble) return;

							_bubble.addClass('_big');

							sm_marker.marker.bubble.open();

							if (_bubble.rater) return;

							var _inds = _bubble.getElements('.indicator');

							_bubble.rater = new Rater(_inds, {
								'property': 'data-value',
								'size': 'absolute',
								'animate': false,
								'type': 'horisontal',
								'max_size': 284
							});
						}).delay(10);
					},

					onMouseout: function onMouseout() {
						if (self.options.is_building && !sm_marker.marker.clicked) {
							if (sm_marker.marker.bubble && sm_marker.marker.bubble.infobox) {
								var _bubble = sm_marker.marker.bubble.infobox._div;

								if (!_bubble) return;

								sm_marker.marker.bubble.infobox._div.removeClass('_big');
							}
						}
					},

					onStopMouseover: function onStopMouseover() {
						if (!self.options.is_building && self.has_opened_bubble) {
							return true;
						}

						return false;
					},

					onBubbleClose: function onBubbleClose() {
						self.has_opened_bubble = false;

						// remove the active class to the label of the current marker when the bubble is closed.
						if (self.map.current_marker && sm_marker === self.map.current_marker && self.map.current_marker.marker.label && self.map.current_marker.marker.label._bubble_content) {
							self.map.current_marker.marker.label._bubble_content.removeClass('_active');
						}
					}
				}
			});

			region.building_markers.push(sm_marker);
		});
	},

	get_bubble_content: function get_bubble_content(data) {
		var header = '';

		if (data.name && data.name != '') {
			header += '<span>' + data.name + '</span>' + data.address + (data.type && data.type != '' ? '<br/>' : '') + '<span class="type' + (data.type.toLowerCase() == 'rental' ? ' _dark' : '') + '">' + data.type + '</span>';
		} else {
			header += '<span>' + data.address + '</span>';
		}

		var content;

		if (this.options.is_building) {
			content = this.get_building_map_bubble_content(data);
		} else {
			var self = this;
			var listings_amount = 0;
			var lis = '';

			this.bubble_images = [];

			Object.each(data.data, function (el) {
				var add_class = el.mask_id ? ' _' + el.mask_id : '';
				var url = self.options.page_context ? el.url + '&pageContext=' + self.options.page_context : el.url;
				if (typeof self.options.view != "undefined" && self.options.view) {
					url += "&view=" + self.options.view;
				}

				var image = window.Missing_img_horisontal;
				var imagesCnt = 0;
				if (el.thumbor_images && el.thumbor_images.length > 0) {
					image = Core.get_smart_image(120, 78, el.thumbor_images[0]);
					imagesCnt = el.thumbor_images.length;
				} else {
					image = el.image;
				}
				lis += '<li data-class="w_blimp_listing" class="clearfix ' + add_class + '" data-' + (el.sold ? 'url' : 'rpc') + '="' + url + '" data-images-cnt="' + imagesCnt + '">' + '<span class="image left">' + '<img src="' + image + '" onerror="this.src=\'' + Missing_img_horisontal + '\';"/>' + '</span>' + '<span class="description">' + (el.unit && el.unit != '' ? '<span class="name ' + (el.in_contract ? '' : 'mt_10') + '">Apt. ' + el.unit + '</span>' : '') + (el.display_bedrooms ? el.display_bedrooms : '') + (el.display_bathrooms ? ', ' + el.display_bathrooms : '') + (el.price ? '<span class="price">' + el.price + '</span>' : '') + (self.options.search_type == 'transactions' && el.sale_date ? '<span class="sold_date"> Sold ' + el.sale_date + '</span>' : '') + (el.in_contract ? '<span class="flag_incontract">In contract</span>' : '') + '</span>' + '</li>';

				listings_amount++;

				self.bubble_images.push(el.image);
			});

			content = '<h3>' + header + '</h3>' + '<ul>' + lis + '</ul>';
		}

		return content;
	},

	get_building_map_bubble_content: function get_building_map_bubble_content(data) {
		var bubble = '' + '<div class="clearfix">' + '<div class="photo_container">' + '<a href="' + data.url + '"><img src="' + (data.photo ? data.photo : Missing_img) + '" onerror="this.src=\'' + Missing_img + '\';"/></a>' + '</div>' + '<div class="info_container clearfix">' + '<div class="name">' + '<a href="' + data.url + '">' + (data.name ? data.name : data.address) + '</a>' + '</div>' + (data.name && data.address ? '<div class="address"><a href="' + data.url + '">' + data.address + '</a></div>' : '') + (data.type ? '<div class="type">' + data.type + '</div>' : '');

		if (this.options.show_starting_price) {
			if (data.avg_price && data.avg_price != '' || data.total && data.total != '') {
				if (data.avg_price && data.avg_price != '') {
					bubble += '<div class="starting_price">' + 'Starting from $<strong>' + Core.add_commas(data.avg_price.toFixed()) + '</strong>' + '</div>';
				}

				if (data.total && data.total != '') {
					bubble += '<div class="available_apts">' + 'Apt' + (data.total > 0 ? 's' : '') + ' Available for ' + (data.type.capitalize() != 'Rental' ? 'sale' : 'rent') + ': <strong>' + data.total + '</strong>' + '</div>';
				}
			} else {
				bubble += '<div class="no_price">No price information available</div>';
			}
		} else {
			if (data.avg_ppsqft && data.avg_ppsqft != '' && data.listings_avg_ppsqft && data.listings_avg_ppsqft != '') {
				bubble += '<div class="avg_price">' + '<div class="price">$' + Core.add_commas(data.avg_ppsqft.toFixed()) + '</div>' + 'Avg. Price / Ft<sup>2</sup> (Recent Closings)' + '<div class="indicator building" data-value="' + data.avg_ppsqft + '">&nbsp;</div>' + '<strong>$' + Core.add_commas(data.listings_avg_ppsqft.toFixed()) + '</strong>' + 'Avg. Price / Ft<sup>2</sup> (Currently Available)' + '<div class="indicator listing" data-value="' + data.listings_avg_ppsqft + '">&nbsp;</div>' + '</div>';
			} else if (data.avg_ppsqft && data.avg_ppsqft != '' || data.listings_avg_ppsqft && data.listings_avg_ppsqft != '') {
				var price = data.avg_ppsqft && data.avg_ppsqft != '' ? data.avg_ppsqft : data.listings_avg_ppsqft;
				var spec = data.avg_ppsqft && data.avg_ppsqft != '' ? 'Recent Closings' : 'Currently Available';

				price = Core.add_commas(price.toFixed());

				bubble += '<div class="avg_price no_indicator building">' + '<div class="price">$' + price + '</div>' + 'Avg. Price / Ft<sup>2</sup> (' + spec + ')' + '</div>';
			} else if (data.providers && data.url.contains('furnished')) {
				bubble += '<div class="providers"><strong>' + data.providers + (data.providers > 1 ? ' companies' : ' company') + '</strong> w/ Furnished Apartments</div>';
			} else {
				bubble += '<div class="no_price">No price information available</div>';
			}
		}

		bubble += (data.url ? '<a class="button" href="' + data.url + '">View Complete Building Info</a>' : '') + '</div>' + '</div>' + '<span class="legend">Click on marker for more info</span>';

		return bubble;
	},

	in_new_york: function in_new_york(lat, lng) {
		//some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if (!lat || !lng) return false;

		return lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4;
	},

	enable: function enable() {
		this.enabled = true;
	},

	disable: function disable() {
		this.enabled = false;
	}
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var SideOptions = new Class({
	Implements: [Options, Events],

	options: {
		has_main_item: false,
		minimum_row: 2,
		maximum_row: 3,
		items_per_row: 3,
		initial_option: 0,
		show_nav_on_mouseover: false,
		with_pagination: false,
		by_region: false
	},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this.active_page_index = 0;

		var self = this;
		var _sideoptions = self._element.getElement('.options');
		var _sideoptions_lis = _sideoptions.getElements('li');
		var _main_container = self._main_container = self._element.getElement('.main_container');
		var _veil = self._element.getElement('.veil');
		var rpc = _sideoptions.getAttribute('data-rpc');
		this.maximum_row = self.options.maximum_row;

		if (_sideoptions_lis.length == 0) self._element.dispose();

		_sideoptions_lis.each(function (option) {
			option.addEvent('click', function () {

				if (option.hasClass('_active')) return;

				self.active_page_index = 0;

				if (self._active_option) self._active_option.removeClass('_active');

				option.addClass('_active');

				if (_veil) _veil.show();

				if (rpc && rpc != '' && !option.content) {

					var _parent_div = new Element('div', {
						'id': 'box_' + (option.get('data-region-id') ? option.get('data-region-id') : option.get('data-id')),
						'class': '_box'
					}).inject(_main_container);

					if (self._pagination) self._pagination.inject(_main_container); // to stay as the last element in the main_container

					var param;
					if (self.options.by_region) {
						param = '?region=' + option.get('data-region-id');
						param += '&company=' + option.get('data-company-id');
					} else {
						param = '&category=' + option.get('data-id');
					}

					var remote = new Remote({
						rpc: rpc + param,
						method: 'get',
						onSuccess: function onSuccess() {
							var data = remote.get_data();

							if (self._active_option) self._active_option.content.hide();

							option.content = _parent_div;
							self._active_option = option;

							if (data && (data.content.length > 0 || _typeof(data.content) === 'object' && Object.keys(data.content).length > 0)) {
								self.create_items(data.content, _parent_div);

								self.maximum_row = _parent_div.getElement('._main') ? self.options.maximum_row - 1 : self.options.maximum_row;
								self.complete_the_container(_parent_div, data.content.length);

								self.post_build(self, _parent_div);
							} else {
								self._element.dispose();

								//self.complete_the_container(_parent_div);
							}

							self.fireEvent('success');
						}
					});
				} else {
					self._active_option.content.hide();
					self._active_option = option;
					option.content.show();
					self.maximum_row = option.content.getElement('._main') ? self.options.maximum_row - 1 : self.options.maximum_row;
					self.post_build(self, option.content);
				}
			});
		});

		if (self.options.initial_option != 0) {
			_sideoptions_lis.each(function (_li) {
				if (_li.get('data-id') == self.options.initial_option) {
					_li.fireEvent('click');
				}
			});
		} else {
			_sideoptions_lis[0].fireEvent('click');
		}
	},

	post_build: function post_build(self, _box) {
		var _veil = self._element.getElement('.veil');
		self._active_box = _box;
		// The new dev has to be reviewed later on
		// self._element.getElement('.side_options_btn_previous').removeEvents().addEvent('click', self.goto_previous.bind(self));
		// self._element.getElement('.side_options_btn_next').removeEvents().addEvent('click', self.goto_next.bind(self));
		self.goto_page(0, true);

		var row_count = self.get_row_count();

		if (row_count <= self.maximum_row) {
			// self._element.getElement('.side_options_btn_previous').hide();
			// self._element.getElement('.side_options_btn_next').hide();
		} else {
			if (!self.options.show_nav_on_mouseover) {
				// self._element.getElement('.side_options_btn_previous').show();
				// self._element.getElement('.side_options_btn_next').show();
			} else {
				self._element.addClass('_nav_on_mouseover');
			}
		}

		if (self.options.with_pagination && row_count > self.maximum_row) {
			self._main_container.addClass('_with_pagination');
			self._pagination = self._element.getElement('.pagination') || new Element('div', { 'class': 'pagination' }).inject(self._main_container);
			self._pagination.show();
			self._pagination.empty();
			self.add_pagination(self._active_box.getElement('._main'));
		} else {
			if (self._pagination) {
				self._main_container.removeClass('_with_pagination');
				self._pagination.hide();
			}
		}

		if (_veil) _veil.hide();
	},

	create_items: function create_items(data, _container) {
		var self = this;
		var _row;
		var counter = 0;

		var previous_item_is_main = false;

		Object.each(data, function (el, i) {

			if (counter % self.options.items_per_row == 0 || previous_item_is_main || self.options.has_main_item && el.promo) {
				counter = 0;
				previous_item_is_main = true;

				_row = new Element('div', {
					class: '_row clearfix'
				}).inject(_container);
			}

			var content = '<div class="caption">' + el.caption + '</div>' + '<div class="cover">' + el.cover + '</div>';

			var style_object;
			if (el.image) {
				style_object = {
					'background': 'url(' + el.image + ') #FAFAFA no-repeat center ' + (el.top || 0) + '%',
					'background-size': 'cover'
				};
			} else {
				style_object = {
					background: '#FAFAFA'
				};
			}

			var _item = new Element('div', {
				'class': '_item' + (self.options.has_main_item && el.promo ? ' _main' : ' _regular'),
				'html': content,
				'data-styles': JSONMOO.encode(style_object)
			}).inject(_row);

			counter++;

			previous_item_is_main = el.promo ? true : false;

			new Picks(_item);
		});
	},

	get_row_count: function get_row_count() {
		return this._active_box.getElements('._row').length;
	},

	goto_previous: function goto_previous(e) {
		e.stop();

		var active = this.active_page_index;
		//console.log('goto_previous', active);
		if (active > 0) {
			this.goto_page(active - 1);
		}
	},

	goto_next: function goto_next(e) {
		e.stop();
		var row_count = this.get_row_count();
		var max_page = Math.ceil(row_count / this.maximum_row);
		max_page = this._active_box.getElement('._main') && row_count > 4 ? max_page - 1 : max_page;

		var active = this.active_page_index;
		//console.log('goto_next', active);
		if (active < max_page - 1) {
			this.goto_page(active + 1);
		}
	},

	goto_page: function goto_page(page_index, is_immediate) {
		this.active_page_index = page_index;

		var self = this;
		var _box = self._active_box;

		self.row_height = _box.getElement('._row').getSize().y;

		var fx = _box.retrieve('fx_scroll');
		if (fx) {
			var new_y = page_index * self.row_height * self.maximum_row;

			if (_box.getElement('._main')) {
				self.row_height = _box.getElement('._row').getSize().y + _box.getElement('._regular').getSize().y;
				new_y = page_index * self.row_height;
			}

			if (is_immediate === true) fx.set(0, new_y);else fx.start(0, new_y);
		}

		//console.log('goto_page', page_index, new_y);

		var max_per_page = self.options.items_per_row * self.maximum_row;
		var items = _box.getElements('._item');

		if (page_index == 0 && this._active_box.getElement('._main')) {
			max_per_page = items.length;
		}

		items.each(function (_i, i) {
			if (i >= self.active_page_index * max_per_page && i < self.active_page_index * max_per_page + max_per_page) {
				self.activate_image(_i);
			}
		});

		if (self._pagination && self._pagination.getElements('a').length > 0) {
			self.update_pagination(page_index);
		}
	},

	activate_image: function activate_image(_i) {
		var attr_styles = _i.getAttribute('data-styles');
		if (attr_styles) {
			_i.setStyles(JSONMOO.decode(attr_styles, false));
			_i.removeAttribute('data-styles');
		}
	},

	complete_the_container: function complete_the_container(_container, current_items) {
		//to put an empty item to maintain the background
		var self = this;
		var _rows = _container.getElements('._row');
		var _last_row;

		if (_rows.length == 0) {
			_last_row = new Element('div', {
				'class': '_row clearfix'
			}).inject(_container);

			_rows = _container.getElements('._row');
		} else {
			_last_row = _rows[_rows.length - 1];
		}

		var _row_to_be_completed = _last_row;
		var current_items = _last_row.getElements('._item').length || 0;
		var minimum_row = self.options.minimum_row;
		var maximum_row = self.maximum_row;
		var row_count = _rows.length;
		var d = current_items == self.options.items_per_row ? 1 : 0;

		this.row_count = row_count;

		if (self.options.has_main_item && _rows.length == 1 && current_items == 1 && _last_row.getElement('._item').hasClass('_main')) return;

		for (var i = current_items - d; i < self.options.items_per_row; i++) {

			if (current_items != self.options.items_per_row) {
				var _div = new Element('div', {
					'class': '_item _empty'
				}).inject(_row_to_be_completed);

				if ((row_count - 1) % 2 == 0) {
					_div.addClass(i % 2 == 0 ? ' x' : '');
				} else {
					_div.addClass(i % 2 != 0 ? ' x' : '');
				}
			}

			if (row_count > maximum_row) {
				//&& !_container.getElement('._main')) {

				var _main_items = _container.getElements('._main');

				self.row_height = _container.getElement('._row').getSize().y;
				var height = maximum_row * self.row_height;

				if (_main_items.length > 0) {
					self.row_height = _container.getElement('._row ._regular').getSize().y;
					var total_main_height = 0;
					_main_items.each(function (_main) {
						total_main_height += _main.getSize().y;
					});
					height = self.row_height + total_main_height;
				}

				_container.setStyles({
					overflow: 'hidden',
					height: height
				});

				if (!_container.retrieve('_blank')) {
					var _blank = new Element('div', {
						styles: {
							height: height //self.options.maximum_row * self.row_height
						}
					}).inject(_container);
					_container.store('_blank', _blank);
				}

				var fx = _container.retrieve('fx_scroll');
				if (!fx) {
					fx = new Fx.Scroll(_container, { link: 'cancel' });
					_container.store('fx_scroll', fx);
				}
				fx.set(0, 0);
			}

			if (row_count == 1 && i == 2 && minimum_row == 2) {
				_row_to_be_completed = new Element('div', {
					'class': '_row clearfix'
				}).inject(_container);

				i = -1; // should be -1 so when 'i++' execute after this condition, it becomes 0;
				d = 0;
				row_count++;
				current_items = 0;
			}
		}
	},

	add_pagination: function add_pagination(with_main) {
		var self = this;
		this._pagination_links = [];
		var row_count = this.get_row_count();

		var x = row_count / this.maximum_row;

		if (x % this.maximum_row != 0 && with_main && row_count > 3) {
			x = x.toInt();
		} else if (x % this.maximum_row != 0) {
			x = Math.ceil(x);
		} else if (this.options.maximum_row == 1) {
			x = row_count;
		}

		// add previous button
		if (row_count > self.maximum_row) {
			new Element('a', {
				// 'href': '#previous',
				'html': '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
				'class': 'side_options_btn_previous',
				events: {
					click: self.goto_previous.bind(self)
				}
			}).inject(this._pagination);
		}

		for (var i = 0; i < x; i++) {
			var _a = new Element('a', {
				'href': '#',
				'html': '',
				'class': i == 0 ? 'selected dots' : 'dots',
				events: {
					click: function (e) {
						if (e && e.stop) e.stop();

						this.goto_page(e.target.index);
					}.bind(this)
				}
			}).inject(this._pagination);

			_a.index = i;
			this._pagination_links.push(_a);
		};

		// add next button
		if (row_count > self.maximum_row) {
			new Element('a', {
				// 'href': '#next',
				'html': '<i class="fa fa-arrow-right" aria-hidden="true"></i>',
				'class': 'side_options_btn_next',
				events: {
					click: self.goto_next.bind(self)
				}
			}).inject(this._pagination);
		}

		this._active_pagination_link = this._pagination_links[0];
	},

	update_pagination: function update_pagination(index) {
		if (index != null) {
			if (this._active_pagination_link) {
				this._active_pagination_link.removeClass('selected');
			}

			this._pagination_links[index].addClass('selected');
			this._active_pagination_link = this._pagination_links[index];
		}
	}
});
'use strict';

var SideOptionsExt = new Class({
	Extends: SideOptions,

	create_items: function create_items(data, _container) {
		var self = this;
		var _row;
		var counter = 0;

		var previous_item_is_main = false;

		Object.each(data.listings, function (listing, i) {
			Object.each(listing.data, function (building, i) {
				//Object.each(buildings, function(el,i){
				if (counter % self.options.items_per_row == 0 || previous_item_is_main || self.options.has_main_item && building.promo) {
					counter = 0;
					previous_item_is_main = true;

					_row = new Element('div', {
						'class': '_row clearfix'
					}).inject(_container);
				}

				var content = '<div class="caption"><span>' + (building.building_name ? building.building_name : building.address) + '</span></div>';

				var style_object;
				if (building.image) {
					style_object = {
						'background': 'url(' + (building.image ? building.image : building.photo) + ') #FAFAFA no-repeat center ' + (building.top || 0) + '%',
						'background-size': 'cover'
					};
				} else {
					style_object = {
						background: '#FAFAFA'
					};
				}

				var _item = new Element('div', {
					'class': '_item' + (self.options.has_main_item && building.promo ? ' _main' : ' _regular'),
					'html': content,
					'data-styles': JSONMOO.encode(style_object)
				}).inject(_row);

				counter++;

				previous_item_is_main = building.promo ? true : false;

				_item.building_id = i;
				_item.listings_data = building.data;
				new Picks(_item);
				//});
			});
		});
	}
});
"use strict";

var Table = new Class({
	Implements: Options,
	options: {},
	initialize: function initialize(_element, options) {
		this._element = document.id(_element);
		if (this._element) {
			this.setOptions(options);
			this.build();
		}
	},
	build: function build() {}
});

Table.RecentClosings = new Class({ //used as data-class in some widgets (i.e. widgets on building overview page)
	Extends: Table,
	build: function build() {
		this.parent();
		// console.log('Table.RecentClosings build');
		if (Page.Bir) {
			Page.Bir.make_table(this._element);
		}
	}
});

Table.Available = new Class({ //used as data-class in some widgets (i.e. widgets on building overview page)
	Extends: Table.RecentClosings,
	build: function build() {
		this.parent();
		// console.log('Table.Available build');
	}
});

Table.Available.ForSale = new Class({
	Extends: Table.Available,
	build: function build() {
		this.parent();

		// console.log('Table.Available.ForSale build');
	}
});
'use strict';

var Videos = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_videos'
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element || document.getElement('.' + this.options.cls);

		if (!this._element) return;

		this.build();
	},

	build: function build() {
		this._vimeo = this._element.getElement('.vimeo');

		Core.add_froogaloop();

		this.button_clicked = false;

		this._imagestrip = this._element.getElement('.w_imagestrip');

		if (!this._imagestrip) return;

		this._controllers = this._imagestrip.getParent();
		this._istrip_container = this._imagestrip.getElement('.w_imagestrip_scroller');

		this.add_categories();
	},

	add_categories: function add_categories() {
		var self = this;
		var _categories = this._controllers.getElements('.video_categories li a'),
		    _selected_category;

		_categories.each(function (_el) {
			_el.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (_el === _selected_category) return;

				self._controllers.addClass('_loading');
				self.inject_imagestrip(_el);

				if (_selected_category) {
					_selected_category.removeClass('_selected');
				}

				_el.addClass('_selected');
				_selected_category = _el;
			});
		});

		_categories[0].fireEvent('click');
	},

	inject_imagestrip: function inject_imagestrip(_el) {
		if (!this._istrip_container) return;

		var self = this;

		if (!_el.istr) {
			var rpc = _el.getAttribute('data-rpc') || _el.get('href');

			if (rpc && rpc != '') {
				new Remote({
					rpc: rpc,
					onSuccess: function onSuccess() {
						var content = this.get_data().content;

						_el.istr = self._imagestrip.clone();
						_el.istr.inject(self._imagestrip, 'after');

						self._imagestrip.dispose();

						_el.istr.getElement('.w_imagestrip_scroller').set('html', content);
						_el.istr_instace = new Imagestrip(_el.istr, {
							auto_move: false,
							amount: self._controllers.hasClass('_categorized') ? 2 : 3
						});

						self.process_photos(_el.istr);
						self._controllers.removeClass('_loading');
						self._imagestrip = _el.istr;
					}
				});
			}
		} else {
			_el.istr.inject(this._imagestrip, 'after');
			this._imagestrip.dispose();

			this._controllers.removeClass('_loading');
			this._imagestrip = _el.istr;
		}
	},

	add_report: function add_report(_active_video) {
		if (!_active_video) return;

		var _info_box = this._element.getElement('.info_box');

		if (_info_box) {
			var _title = _info_box.getElement('.title');
			var _date = _info_box.getElement('.date');
			var _description = _info_box.getElement('.description');
			var _links_cont = _info_box.getElement('.links');
			var title = _active_video.getElement('.name').get('text');
			var date = _active_video.getElement('.date').get('text');
			var description = _active_video.getElement('.description').get('text');
			var _buttons = _active_video.getElements('.market_insight_report_buttons a');

			_title.set('text', title);
			_date.set('text', date);
			_description.set('text', description);
			_links_cont.empty();

			if (_buttons.length > 0) {
				_buttons.each(function (_btn) {
					var _btn_cloned = _btn.clone();
					_btn_cloned.inject(_links_cont);
				});
			}

			_info_box.show();
		}
	},

	process_photos: function process_photos(_istr) {
		var self = this;
		var _photos = _istr.getElements('.w_imagestrip_photo');

		_photos.each(function (_el) {
			var _parent = _el.getElement('img').getParent();

			_parent.adopt(new Element('div', { 'class': 'veil' }));

			if (_el.getProperty('data-rpc')) {
				_parent.adopt(new Element('div', { 'class': 'now_playing', 'html': 'Now Playing' }));
				_parent.adopt(new Element('div', { 'class': 'play' }));
			}

			_el.addEvents({
				'click': function click(e) {
					self.user_click = !!e;

					self.handle_video_select(_el);
					self.add_report(_el);

					if (self.user_click) {
						self.handle_play();
					}
				},

				'touchstart': function touchstart() {
					this.fireEvent('click');
				},

				'mouseenter': function mouseenter() {
					this.addClass('_hover');
				},

				'mouseleave': function mouseleave() {
					this.removeClass('_hover');
				}
			});
		});

		if (!_istr.init_click) {
			_photos[0].fireEvent('click');
			_istr.init_click = true;
		}

		$(document.body).setStyle('cursor', 'default');
	},

	handle_video_select: function handle_video_select(_el) {
		if (this._current_thumbnail === _el) {
			if (_el.hasClass('_playing')) return;

			if (this.player) {
				this.player.api('play');
			}

			return;
		}

		this.is_playing = false;

		if (this._current_thumbnail) {
			this._current_thumbnail.removeClass('_current').removeClass('_playing').removeClass('_hover');
		}

		_el.addClass('_current');

		this._current_thumbnail = _el;

		var rpc = _el.getProperty('data-rpc');
		this._vimeo.set('html', '<div class="veil">&nbsp;</div>');
		this._vimeo.addClass('_loading');

		var self = this;
		if (rpc) {
			new Remote({
				rpc: rpc,

				onSuccess: function onSuccess() {
					var content = this.get_data().content + '<div class="veil">&nbsp;</div>';
					self._vimeo.set('html', content);
					self._vimeo.removeClass('_with_image');
					self._vimeo.removeClass('_loading');

					self.get_player();

					self.fireEvent('postRpc');
				}
			});
		} else {
			var _image = _el.getElement('.w_imagestrip_image img');

			if (_image) {
				var content = '<img class="article_image" src="' + _image.get('src') + '" />';

				self._vimeo.set('html', content);
				self._vimeo.addClass('_with_image');
				self._vimeo.removeClass('_loading');
			}
		}
	},

	get_player: function get_player() {
		var _iframe = this._vimeo.getElement('iframe');

		if (!_iframe) return;

		this.player = Froogaloop(_iframe);
		this.player.addEvent('ready', this.handle_ready.bind(this));
	},

	handle_ready: function handle_ready() {
		this.player.addEvent('pause', this.handle_pause.bind(this));
		this.player.addEvent('finish', this.handle_finish.bind(this));
		this.player.addEvent('playProgress', this.handle_play.bind(this));

		this._vimeo.removeClass('_loading');

		if (this.user_click) {
			this.player.api('play');
		}
	},

	handle_pause: function handle_pause() {
		this._current_thumbnail.removeClass('_playing');
		this.is_playing = false;
	},

	handle_finish: function handle_finish() {
		this.handle_pause();
	},

	handle_play: function handle_play() {
		if (this.is_playing) return;

		this._current_thumbnail.addClass('_playing');
		this.is_playing = true;
	}
});
'use strict';

Page.Ndv = new Class({
	Extends: Page,

	build: function build() {
		new Photogallery(document.id('building_gallery'), {
			width_by_thumbs: 0,
			no_fullscreen_opt: true,
			single_img_cls: '_single_img'
		});

		this.parent();

		var _building_gallery = document.getElement('.w_management_company_gallery');
		if (_building_gallery) {
			new ManagementCompanyGallery(_building_gallery, {
				region_result_max_items: 4,
				type: 'building'
			});
		}

		new Videos();
		new MapView();
		//new BuildingTours(); // //NCR-1876
		new SalesData(document.getElement('.w_sales_data'));
	}
});
//# sourceMappingURL=ndv.js.map
